var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConeLogistico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 503.56298828125 453.04046630859375",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-6",
    gradientUnits: "userSpaceOnUse",
    x1: 17198.18,
    y1: 15849.14,
    x2: 21380.1,
    y2: 15849.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-7",
    gradientUnits: "userSpaceOnUse",
    x1: 17198.18,
    y1: 14833.57,
    x2: 21380.1,
    y2: 14833.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-47",
    gradientUnits: "userSpaceOnUse",
    x1: 14845.47,
    y1: 12015.68,
    x2: 10537.56,
    y2: 12015.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-52",
    gradientUnits: "userSpaceOnUse",
    x1: 21705.11,
    y1: 12015.68,
    x2: 17397.21,
    y2: 12015.68,
    xlinkHref: "#gradient-53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-53",
    gradientUnits: "userSpaceOnUse",
    x1: 14845.47,
    y1: 12015.68,
    x2: 10537.56,
    y2: 12015.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70072,
    style: {
      stopColor: "rgb(120, 127, 139)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-58",
    gradientUnits: "userSpaceOnUse",
    x1: 21705.11,
    y1: 12015.68,
    x2: 17397.21,
    y2: 12015.68,
    xlinkHref: "#gradient-59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-59",
    gradientUnits: "userSpaceOnUse",
    x1: 14845.47,
    y1: 12015.68,
    x2: 10537.56,
    y2: 12015.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-62",
    gradientUnits: "userSpaceOnUse",
    x1: 18098.49,
    y1: 11541.64,
    x2: 14619.82,
    y2: 11541.64,
    xlinkHref: "#gradient-61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-63",
    gradientUnits: "userSpaceOnUse",
    x1: 14007.41,
    y1: 12094.67,
    x2: 19502.29,
    y2: 12094.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ED3237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#ED3237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#BE5A45"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-65",
    gradientUnits: "userSpaceOnUse",
    x1: 21218.51,
    y1: 8711,
    x2: 22435.66,
    y2: 8711,
    xlinkHref: "#gradient-64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-66",
    gradientUnits: "userSpaceOnUse",
    x1: 14217.74,
    y1: 8711,
    x2: 9909.83,
    y2: 8711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-70",
    gradientUnits: "userSpaceOnUse",
    x1: 21643.36,
    y1: 6844.76,
    x2: 22860.51,
    y2: 6844.76,
    xlinkHref: "#gradient-69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-71",
    gradientUnits: "userSpaceOnUse",
    x1: 23061.42,
    y1: 6847.71,
    x2: 18753.51,
    y2: 6847.71
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-72",
    gradientUnits: "userSpaceOnUse",
    x1: 13869.66,
    y1: 6847.71,
    x2: 9561.73,
    y2: 6847.71,
    xlinkHref: "#gradient-71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-73",
    gradientUnits: "userSpaceOnUse",
    x1: 17198.18,
    y1: 15849.14,
    x2: 21380.1,
    y2: 15849.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-74",
    gradientUnits: "userSpaceOnUse",
    x1: 17198.18,
    y1: 14833.57,
    x2: 21380.1,
    y2: 14833.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-77",
    gradientUnits: "userSpaceOnUse",
    x1: 15260.26,
    y1: 13572.95,
    x2: 10952.34,
    y2: 13572.95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-85",
    gradientUnits: "userSpaceOnUse",
    x1: 14845.47,
    y1: 12015.68,
    x2: 10537.56,
    y2: 12015.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-92",
    gradientUnits: "userSpaceOnUse",
    x1: 22175.6,
    y1: 10363.33,
    x2: 17867.69,
    y2: 10363.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-95",
    gradientUnits: "userSpaceOnUse",
    x1: 14460.53,
    y1: 10363.33,
    x2: 10152.64,
    y2: 10363.33,
    xlinkHref: "#gradient-92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-96",
    gradientUnits: "userSpaceOnUse",
    x1: 22175.6,
    y1: 10363.33,
    x2: 17867.69,
    y2: 10363.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-97",
    gradientUnits: "userSpaceOnUse",
    x1: 20951.73,
    y1: 10363.33,
    x2: 22168.87,
    y2: 10363.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#F7E017"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78759,
    style: {
      stopColor: "rgb(229, 172, 49)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#E19E38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#F05436"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-98",
    gradientUnits: "userSpaceOnUse",
    x1: 14460.53,
    y1: 10363.33,
    x2: 10152.64,
    y2: 10363.33,
    xlinkHref: "#gradient-96"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59563,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-99",
    gradientUnits: "userSpaceOnUse",
    x1: 11264.87,
    y1: 10363.33,
    x2: 12482.02,
    y2: 10363.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#F7E017"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#E19E38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#E29F38"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-100",
    gradientUnits: "userSpaceOnUse",
    x1: 13905.52,
    y1: 10025.5,
    x2: 18617.81,
    y2: 10025.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#F28000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57708,
    style: {
      stopColor: "rgb(243, 129, 30)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#F58634"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#F58634"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-101",
    gradientUnits: "userSpaceOnUse",
    x1: 15620.42,
    y1: 10193.6,
    x2: 16912.18,
    y2: 10193.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#3BB9B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#25777B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#25777B"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-102",
    gradientUnits: "userSpaceOnUse",
    x1: 19173.97,
    y1: 10486.99,
    x2: 12009.67,
    y2: 10486.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#F28000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#F8B732"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#F58634"
    }
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-103",
    gradientUnits: "userSpaceOnUse",
    x1: 22713.34,
    y1: 8711,
    x2: 18405.41,
    y2: 8711,
    xlinkHref: "#gradient-104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-104",
    gradientUnits: "userSpaceOnUse",
    x1: 14217.74,
    y1: 8711,
    x2: 9909.83,
    y2: 8711,
    gradientTransform: "matrix(0.9962004397796568, 0, 0, 1, 37.6529961552041, 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-105",
    gradientUnits: "userSpaceOnUse",
    x1: 21218.51,
    y1: 8711,
    x2: 22435.66,
    y2: 8711,
    xlinkHref: "#gradient-106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-106",
    gradientUnits: "userSpaceOnUse",
    x1: 10998.09,
    y1: 8711,
    x2: 12215.23,
    y2: 8711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#E5E53E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#DFD634"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#D6DF36"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-107",
    gradientUnits: "userSpaceOnUse",
    x1: 23061.42,
    y1: 6847.71,
    x2: 18753.51,
    y2: 6847.71
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-108",
    gradientUnits: "userSpaceOnUse",
    x1: 21643.36,
    y1: 6844.76,
    x2: 22860.51,
    y2: 6844.76,
    xlinkHref: "#gradient-109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-109",
    gradientUnits: "userSpaceOnUse",
    x1: 10573.23,
    y1: 6844.76,
    x2: 11790.37,
    y2: 6844.76
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#76C15A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#478048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#14B255"
    }
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-110",
    gradientUnits: "userSpaceOnUse",
    x1: 13869.66,
    y1: 6847.71,
    x2: 9561.73,
    y2: 6847.71,
    xlinkHref: "#gradient-107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-111",
    gradientUnits: "userSpaceOnUse",
    x1: 12215.21,
    y1: 6519.93,
    x2: 21245.49,
    y2: 6519.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#50BB7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988235,
    style: {
      stopOpacity: 1,
      stopColor: "#0E9451"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#A53690"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-112",
    gradientUnits: "userSpaceOnUse",
    x1: 14217.74,
    y1: 8711,
    x2: 9909.83,
    y2: 8711,
    gradientTransform: "matrix(0.9962004397796568, 0, 0, 1, 37.6529961552041, 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-113",
    gradientUnits: "userSpaceOnUse",
    x1: 14845.47,
    y1: 12015.68,
    x2: 10537.56,
    y2: 12015.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#FEFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#404A5C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4300307631492615, 0, 0, 0.4300307631492615, 8.055938720703125, 1.4210854715202004e-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 503.56298828125,
    height: 453.04046630859375,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.192704677581787, 0, 0, 2.822704677581787, 5.549966812133789, -1.3016357421875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.027534762397408485, 0, 0, 0.027534762397408485, -291.99407958984375, -130.83660578537229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19732.92 16204.6l-28.92 0 -110.35 0 -259.17 0 -110.37 0 -259.14 0 -110.37 0 -259.17 0 -110.34 0 -259.17 0 -110.37 0 -259.14 0 -110.37 0 -259.17 0 -110.35 0 -62.42 0c517.03,-44.03 570.92,-103.8 570.92,-103.8l288.8 -655.86c3.41,-3.84 5.15,-7.7 5.2,-11.6 0,-0.05 0,-0.11 0,-0.18 0,-20.89 -48.77,-40.94 -138.05,-59.47l147.57 0 110.37 0 259.15 0 110.37 0 259.16 0 610.35 0 259.16 0 610.38 0 325.44 0 0 830.91zm-1553.9 -771.26l0 0zm0 -0.18l0 0z",
    style: {
      fill: "url('#gradient-6')"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 18209.52,
    y: 15940.08,
    className: "fil1 fnt0 label_camada_6",
    style: {
      whiteSpace: "pre",
      fill: "rgb(55, 52, 53)",
      fontWeight: "bold",
      fontSize: "254.01px",
      fontFamily: "'Arial'",
      fontWeight: "Arial"
    }
  }, "Acidente"), /*#__PURE__*/React.createElement("g", {
    id: "_1962302970432",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 5.4569682106375694e-12, -56.876111796023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 camada_6 botao area_cor_camada_6",
    d: "M16739.33 16417.12c-4.6,0 -9.16,0 -13.72,0 -57.9,-0.07 -113.16,-0.57 -165.62,-1.44 -23.89,-0.41 -47.13,-0.89 -69.93,-1.44 -57.55,-1.39 -111.66,-3.28 -162.57,-5.58 -23.5,-1.06 -46.29,-2.2 -68.46,-3.45 -57.13,-3.18 -109.87,-6.92 -158.5,-11.11 -23.03,-1.99 -45.17,-4.07 -66.4,-6.26 -56.95,-5.81 -107.57,-12.32 -152.57,-19.21 -18.96,-2.92 -36.88,-5.91 -53.87,-8.94 -306.55,-54.92 -305.98,-129.47 -305.98,-129.47l-185.74 -818.08c7.56,16.56 27.75,32.6 59.22,47.91l0 0c21.35,10.41 47.88,20.47 79.14,30.14 101.52,103.37 649.01,182.32 1309.18,182.32 660.15,0 1207.64,-78.95 1309.16,-182.32 31.26,-9.67 57.79,-19.73 79.16,-30.14l0 0c31.45,-15.31 51.66,-31.35 59.2,-47.91l-185.73 818.08c0,0 -34.66,74.55 -367.17,129.47 -42.04,6.93 -88.88,13.57 -140.97,19.68 -24.53,2.9 -50.12,5.66 -77.06,8.32 -53.9,5.29 -112.82,10.05 -177.03,14.12 -23.95,1.53 -48.63,2.94 -74.09,4.26 -53.72,2.79 -110.95,5.11 -171.74,6.92 -23.56,0.68 -47.65,1.3 -72.31,1.82 -53.41,1.14 -109.47,1.87 -168.26,2.17 -18.85,0.09 -37.92,0.14 -57.34,0.14zm1495.04 -1019.45l0 0 0 0zm-2901.73 0l0 0 0 0z",
    style: {
      fill: "rgb(38, 36, 37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 area_cor_interna_1_camada_6",
    d: "M18171.83 15460.05c-19.08,-9.26 -42.28,-18.29 -69.28,-26.99 -40.52,-64.62 -254.16,-120.82 -563.82,-155.98 102.97,-9.31 191.42,-20.24 267.46,-32.06 264.47,38.93 428.18,92.85 428.18,152.42l0 0c0,0.09 0,0.16 0,0.23l0 0c-0.03,4.86 -1.15,9.68 -3.34,14.47 -7.54,16.56 -27.75,32.6 -59.2,47.91zm-2776.64 0c-31.47,-15.31 -51.66,-31.35 -59.22,-47.91 -2.17,-4.79 -3.3,-9.61 -3.33,-14.47l0 0c0,-0.07 0,-0.14 0,-0.23l0 0c0,-56.84 149.01,-108.52 392.31,-146.94 74.77,11.54 162.84,22.08 266.64,30.89 -289.77,35.37 -488.23,89.65 -527.14,151.67 -27,8.7 -50.2,17.73 -69.26,26.99z",
    style: {
      fill: "rgb(41, 35, 41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M15467.89 15488.16l0 -0.15 -0.47 0 -6.22 -2 0 -0.29 -0.87 0 -5.82 -1.92 0 -0.36 -1.04 0 -5.65 -1.93 0 -0.35 -1 0 -0.38 -0.14 -5.31 -1.89 0 -0.25 -0.7 0 -5.99 -2.2 0 -0.08 -0.21 0 -0.52 -0.2 -0.75 -0.27c-3.5,-1.32 -6.91,-2.65 -10.23,-3.98l0 -0.12 -0.32 0 -1.2 -0.48 -0.86 -0.35 -2.64 -1.08 0 -0.36 -0.88 0c-2.57,-1.07 -5.09,-2.15 -7.56,-3.22l-0.8 -0.36c-3.47,-1.52 -6.82,-3.04 -10.06,-4.58l-0.99 -0.47 -2.19 -1.09c2.73,-1.33 5.55,-2.66 8.46,-3.98l0.64 0 0 -0.29 4.48 -1.99 0.53 0 0 -0.23 4.79 -2.05 0.23 0 0 -0.1c7.22,-3.04 14.89,-6.05 22.99,-9.03l0.43 0 0 -0.16 5.89 -2.12 0.8 0 0 -0.29c6.41,-2.26 13.07,-4.51 19.98,-6.74 -4.62,7.37 -6.99,14.85 -6.99,22.41 0,11.81 5.76,23.42 16.85,34.7l-6.42 -2.01zm2703.9 -28.13l-2.2 1.1 -0.96 0.46c-3.22,1.52 -6.54,3.04 -9.98,4.55l-1.07 0.47 -1.98 0.86 -1.01 0 0 0.43 -4.39 1.86 -0.62 0 0 0.25 -2.68 1.1 -1.39 0.55 -0.92 0.37 -0.03 0 0 0.01c-3.33,1.34 -6.75,2.68 -10.26,3.99l-1.4 0.52 -6.34 2.33 -0.41 0 0 0.15 -5.04 1.8 -0.93 0.33 -0.72 0 0 0.25 -5.93 2.03 -0.76 0 0 0.26 -6.09 2.02 -0.6 0 0 0.21 -0.02 0 -6.47 2.08 -0.2 0 0 0.06 -6.71 2.1c11.1,-11.28 16.86,-22.89 16.86,-34.7 0,-7.56 -2.37,-15.04 -6.99,-22.41 4.63,1.5 9.16,2.99 13.57,4.5l0 0.25 0.7 0 5.99 2.09 0 0.19 0.52 0 6.17 2.23 0 0.05 0.15 0c10.11,3.72 19.56,7.49 28.29,11.3l0 0.11 0.26 0 4.76 2.11 0 0.17 0.37 0 4.65 2.15 0 0.14 0.28 0 3.53 1.68z",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_interna_3_camada_6",
    d: "M16441.12 15606.32c12.74,1.82 23.98,3.2 32.22,3.58 43.46,2.08 65.19,11 98.16,12.01l-0.75 47.84c69.69,1.82 140.12,2.76 212.8,2.76l0 0c660.14,0 1207.88,-78.95 1309.04,-182.3 -111.65,34.57 -283.99,63.99 -496.79,85.3 -231.54,23.26 -511.03,36.84 -812.25,36.84 -117.64,0 -232.28,-2.07 -342.43,-6.03z",
    style: {
      fill: "rgb(96, 96, 98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_interna_3_camada_6",
    d: "M16570.75 15669.75l0.75 -47.84c-32.97,-1.01 -54.7,-9.93 -98.16,-12.01 -8.24,-0.38 -19.48,-1.76 -32.22,-3.58 -170.09,-6.1 -328.94,-16.66 -469.81,-30.81 -212.8,-21.31 -385.14,-50.73 -496.79,-85.3 89.92,92.03 534.26,164.7 1096.23,179.54z",
    style: {
      fill: "rgb(96, 96, 98)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil1 area_cor_interna_2_camada_6",
    d: "M17606.58 15581.36c-159.97,-46.14 -475.99,-77.57 -839.84,-77.57 -363.86,0 -680.66,31.43 -839.85,77.57 -220.35,-22.85 -398.35,-54.45 -514.41,-91.48 -10.98,-12.1 -17.25,-24.56 -17.25,-37.29 0,-8.04 2.35,-16.08 7.06,-24.02 237.6,-79.29 759.07,-134.28 1364.45,-134.28 605.37,0 1126.84,54.99 1363.66,134.28 4.71,7.94 7.06,15.98 7.06,24.02 0,12.73 -5.49,25.19 -17.25,37.29 -115.28,37.03 -294.07,68.63 -513.63,91.48l0 0z",
    style: {
      fill: "rgb(24, 23, 23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15719.8896484375 15823.3603515625 L 15754.1298828125 16072.6904296875 L 15862.4697265625 15924.8896484375 Z",
    className: "fil2 area_cor_fonte_camada_6",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17851.259765625 15843.9404296875 L 17832.2109375 16072.6904296875 L 17723.869140625 15924.8896484375 Z",
    className: "fil2 area_cor_fonte_camada_6",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.733167 0 0 1 4345.46 6726.65)"
  }, /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "normal",
      fontSize: "498.85px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 17098.15,
    y: 9401,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -290.22107015740085, 0)",
    className: "label camada_6 area_cor_fonte_camada_6"
  }, "0")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_interna_1_camada_7",
    d: "M17254.62 15319.41l-146.19 -17.28c-113.03,3.66 -238.13,5.65 -374.52,5.65 -309.72,0 -552.37,-10.27 -742.27,-26.36 -290.12,35.35 -488.31,89.64 -527.5,151.63 229.84,-73.93 733.98,-125.27 1319.5,-125.27 165.03,0 323.28,4.15 470.98,11.63z",
    style: {
      fill: "rgb(34, 29, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 area_cor_interna_1_camada_7",
    d: "M17108.43 15302.13l146.19 17.28c376.79,19.15 683.49,60.53 847.77,113.64l0 0c-40.69,-64.62 -253.95,-120.8 -563.67,-155.99 -122.08,11.03 -264.5,19.8 -430.29,25.07z",
    style: {
      fill: "rgb(34, 29, 34)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_3_camada_6",
    d: "M16625.42 15615.68c77.77,-15.47 246.36,-19.94 320.75,-42.82l158.44 -20.52c20.78,-3.89 113.04,-12.08 189.84,-27.63 -70.52,-7.57 -147.81,-13.69 -231.86,-18.04 -102.41,23.13 -370.99,29.79 -436.68,30.08 -90.34,0.45 -174.39,-8.61 -256.02,-9.6 -26.09,-0.33 -61.83,-2.69 -97.58,-7.16 -155.54,14.61 -279.21,35.91 -351.67,61.23l0.97 0.08 21.25 1.95 5.32 0.41c9.18,0.83 18.84,1.65 28.02,2.44l14.49 1.16 15.46 1.28 20.77 1.61 10.14 0.79 26.09 1.9 9.66 0.71 26.08 1.82 8.21 0.49 28.02 1.82 8.21 0.54 24.16 1.49 13.52 0.74 26.09 1.49 5.31 0.29c11.11,0.58 21.74,1.16 32.85,1.7l3.86 0.21c10.15,0.49 20.77,1.03 31.4,1.53l7.73 0.33 30.92 1.36 7.72 0.33 32.85 1.29 2.42 0.12c12.07,0.46 24.15,0.87 35.74,1.28l2.9 0.13c12.08,0.37 24.15,0.78 36.23,1.16l1.93 0.04c12.56,0.37 25.12,0.74 37.68,1.07l0.48 0c12.56,0.33 24.64,0.62 37.2,0.91l4.35 0.13c12.07,0.24 24.63,0.53 37.19,0.74l0.97 0.04c12.08,0.21 24.15,0.42 36.23,0.62l6.28 0.09 26.08 0.37z",
    style: {
      fill: "rgb(55, 52, 53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_3_camada_6",
    d: "M17294.45 15524.71c-76.8,15.55 -169.06,23.74 -189.84,27.63l-158.44 20.52c-74.39,22.88 -242.98,27.35 -320.75,42.82l10.15 0.08 2.41 0.04c13.04,0.17 25.6,0.25 38.16,0.37l2.9 0c26.57,0.21 53.62,0.34 80.67,0.34l0 0c27.05,0 53.62,-0.13 80.67,-0.34l2.42 0c12.56,-0.12 25.6,-0.2 38.16,-0.37l2.9 -0.04c12.07,-0.12 23.67,-0.29 35.74,-0.45l6.28 -0.09c12.56,-0.2 24.64,-0.41 36.72,-0.62l0.96 -0.04c12.56,-0.21 24.64,-0.5 37.2,-0.74l4.34 -0.13c12.08,-0.25 24.64,-0.58 36.72,-0.91l0.48 0c12.56,-0.33 25.12,-0.7 37.68,-1.07l1.93 -0.04c12.08,-0.38 24.15,-0.75 36.23,-1.16l2.9 -0.13c12.07,-0.41 23.67,-0.82 35.74,-1.28l2.9 -0.08c10.63,-0.46 21.74,-0.87 32.37,-1.33l7.73 -0.33 30.91 -1.36 7.73 -0.33c10.63,-0.5 21.25,-1 31.88,-1.53l3.38 -0.21c11.11,-0.54 22.22,-1.12 33.33,-1.7l4.83 -0.29 26.57 -1.49 13.05 -0.74 24.63 -1.53 7.73 -0.46 28.5 -1.86 7.73 -0.49 26.08 -1.82 9.67 -0.71 26.08 -1.9 10.14 -0.79 20.29 -1.61 16.43 -1.28 14.01 -1.16 28.5 -2.44 4.83 -0.41 21.73 -1.99 0.49 -0.04c-65.22,-22.71 -171,-42.2 -303.85,-56.51z",
    style: {
      fill: "rgb(55, 52, 53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_3_camada_6",
    d: "M16272.31 15519.99c35.75,4.47 71.49,6.83 97.58,7.16 81.63,0.99 165.68,10.05 256.02,9.6 65.69,-0.29 334.27,-6.95 436.68,-30.08 -94.68,-4.92 -196.61,-7.61 -302.88,-7.61 -179.21,0 -346.35,7.69 -487.4,20.93z",
    style: {
      fill: "rgb(55, 52, 53)"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 H 343.454102 V 325.415314 H 0 V 0 Z",
    id: "rect-1",
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.027534766122698777, 0, 0, 0.027534766122698777, -288.24285888671875, -130.62152409744021)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-6",
    transform: "matrix(0.08039601147174835, 0, 0, 0.08039601147174835, -791.951231257149, -217.25234985351562)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19094.01 12624.25l2105.35 0 0 -1217.15 -2067.33 0c190.04,40.39 297.2,86.1 297.2,134.54 0,0.11 0,0.22 0,0.33 -0.05,6.67 -2.17,13.32 -6.24,19.91l-328.98 1062.37zm335.22 -1082.61l0 0zm0 0.33l0 0z",
    style: {
      fill: "url('#gradient-52')"
    },
    transform: "matrix(0.97848379611969, 0, 0, 0.97848379611969, 262.8875844938657, 284.7203369140623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M20526.87 12015.68c0,336.11 272.46,608.57 608.57,608.57 336.09,0 608.55,-272.46 608.55,-608.57 0,-336.11 -272.46,-608.58 -608.55,-608.58 -336.11,0 -608.57,272.47 -608.57,608.58z",
    style: {
      fill: "url('#gradient-54')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M14339.71 12624.25l-2105.34 0 0 -1217.15 2067.33 0c-190.05,40.39 -297.21,86.1 -297.21,134.54 0,0.11 0,0.22 0,0.33 0.06,6.67 2.17,13.32 6.25,19.91l328.97 1062.37zm-335.22 -1082.61l0 0zm0 0.33l0 0z",
    style: {
      fill: "url('#gradient-53')"
    },
    transform: "matrix(0.9472152780563605, 0, 0, 0.9472152780563605, 1033.0062397263068, 625.8591196112118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 camada_5 botao area_area_fundo_circulo_camada_5",
    d: "M12906.85 12015.68c0,336.11 -272.46,608.57 -608.57,608.57 -336.09,0 -608.55,-272.46 -608.55,-608.57 0,-336.11 272.46,-608.58 608.55,-608.58 336.11,0 608.57,272.47 608.57,608.58z",
    style: {
      fill: "rgb(171, 49, 45)"
    },
    transform: "matrix(1.1411631707842473, 0, 0, 1.1411631707842473, -1678.7947927333648, -1638.8985771437578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14685.759765625 12156.919921875 L 14751.4697265625 12507.6103515625 L 14959.330078125 12299.75 Z",
    className: "fil4",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18774.939453125 12185.8603515625 L 18738.390625 12507.6103515625 L 18530.529296875 12299.75 Z",
    className: "fil4",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7 botao camada_5 area_cor_camada_5",
    d: "M19502.29 11536.01c0,-164.77 -1230.07,-298.35 -2747.43,-298.35 -1517.37,0 -2747.44,133.58 -2747.44,298.35 0,6.6 2.2,13.16 6.09,19.66l351.94 1136.53c0,0 -2.7,259.47 2305.77,259.47 2308.46,0 2473.03,-259.47 2473.03,-259.47l351.96 -1136.53c3.89,-6.5 6.08,-13.06 6.08,-19.66z",
    style: {
      fill: "rgb(120, 43, 36)"
    },
    transform: "matrix(0.9244342200451858, 0, 0, 0.9244342200451858, 1287.571978992618, 913.9432319909197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9 area_cor_interna_2_camada_5",
    d: "M16641.28 11834.1l0 -0.06 -11.4 0c-62.55,-0.31 -124.51,-0.85 -185.9,-1.59l0 -0.04 -2.99 0c-66.05,-0.82 -131.4,-1.88 -195.94,-3.2l0 -0.07 -3.5 0c-23.95,-0.49 -47.78,-1.02 -71.5,-1.58l0 -0.04 -1.98 0c-21.18,-0.5 -42.25,-1.03 -63.24,-1.59l0 -0.04 -1.78 0c-19.6,-0.52 -39.12,-1.06 -58.55,-1.63l0 -0.01 -0.25 0c-17.38,-0.5 -34.69,-1.02 -51.93,-1.56l0 -0.07 -2.15 0c-32.13,-1 -64.04,-2.07 -95.69,-3.2l0 -0.06 -1.36 0c-14.26,-0.51 -28.5,-1.02 -42.66,-1.56l0 -0.07 -1.73 0c-27.35,-1.03 -54.48,-2.12 -81.43,-3.25l0 -0.01 -0.17 0 -37.33 -1.6 0 -0.03 -0.68 0c-23.85,-1.04 -47.55,-2.11 -71.06,-3.23l0 -0.03 -0.68 0 -33.57 -1.63 0 0 -0.11 0c-10.86,-0.53 -21.72,-1.06 -32.5,-1.61l0 -0.02 -0.24 0c-20.73,-1.05 -41.28,-2.14 -61.72,-3.25l0 -0.01 -0.23 0 -29.12 -1.59 0 -0.04 -0.78 0c-37.21,-2.08 -73.89,-4.26 -110.1,-6.52l0 -0.01 -0.05 0c-33.6,-2.09 -66.72,-4.26 -99.41,-6.5l0 -0.02 -0.18 0 -22.65 -1.56 0 -0.07 -0.98 0c-29.98,-2.1 -59.54,-4.27 -88.7,-6.5l0 -0.02 -0.31 0 -20.88 -1.61 0 -0.02 -0.25 0c-33.66,-2.62 -66.72,-5.33 -99.22,-8.1l0 -0.05 -0.57 0 -19 -1.63 0 0 -0.03 0c-24.27,-2.12 -48.13,-4.29 -71.71,-6.49l0 -0.03 -0.42 0c-11.36,-1.06 -22.62,-2.13 -33.82,-3.22l0 -0.05 -0.51 0c-21.87,-2.11 -43.47,-4.25 -64.71,-6.44l0 -0.08 -0.79 0 -15.52 -1.62 0 -0.01 -0.11 0c-20.36,-2.13 -40.47,-4.28 -60.22,-6.48l0 -0.04 -0.36 0 -14.31 -1.62 0 -0.01 -0.11 0c-14.27,-1.61 -28.36,-3.24 -42.29,-4.89l0 0 -0.03 0c-48.85,-5.77 -95.61,-11.76 -140.19,-17.93l0 -0.01 -0.12 0 -11.3 -1.56 0 -0.07 -0.46 0c-22.72,-3.19 -44.86,-6.43 -66.39,-9.72l0 -0.06 -0.39 0c-7.03,-1.08 -13.91,-2.17 -20.81,-3.25l0 -0.02 -0.08 0c-40.27,-6.33 -78.3,-12.85 -114.06,-19.52l0 -0.04 -0.19 0c-25.59,-4.78 -50,-9.65 -73.18,-14.59l0 -0.09 -0.39 0c-15.05,-3.21 -29.63,-6.46 -43.64,-9.74l0 -0.04 -0.17 0 -6.35 -1.53 0 -0.1 -0.43 0c-15.79,-3.76 -30.84,-7.56 -45.23,-11.41l0 0 -0.03 0c-17.94,-4.8 -34.83,-9.65 -50.51,-14.56l0 -0.12 -0.37 0c-1.55,-0.48 -3,-0.98 -4.52,-1.46l0 -0.17 -0.51 0c-10.09,-3.23 -19.74,-6.48 -28.84,-9.75l0 -0.03 -0.09 0c-4.48,-1.61 -8.74,-3.23 -12.96,-4.86l0 -0.04 -0.09 0 -2.76 -1.03c1.9,-0.75 3.97,-1.49 5.92,-2.22l0.19 0 0 -0.07c10.08,-3.82 20.83,-7.6 32.25,-11.35l0.37 0 0 -0.12 4.64 -1.51 0.25 0 0 -0.08c1.61,-0.51 3.15,-1.04 4.78,-1.55l0.11 0 0 -0.03c12.13,-3.83 24.95,-7.63 38.46,-11.39l0.67 0 0 -0.19c3.7,-1.02 7.55,-2.04 11.35,-3.06l0.06 0 0 -0.02c16.36,-4.39 33.6,-8.74 51.79,-13.03l0.39 0 0 -0.09c11.51,-2.71 23.44,-5.4 35.67,-8.06l0.2 0 0 -0.05c7.46,-1.62 15.04,-3.24 22.77,-4.85l0.06 0 0 -0.01 7.84 -1.61 0.31 0 0 -0.07c10.59,-2.17 21.38,-4.32 32.43,-6.46l0.19 0 0 -0.04c8.43,-1.62 17.02,-3.24 25.72,-4.85l0.36 0 0 -0.07c11.73,-2.17 23.61,-4.32 35.82,-6.45l0.06 0 0 -0.01 9.48 -1.62 0.3 0 0 -0.05 9.25 -1.58 0.54 0 0 -0.1c22.61,-3.83 45.92,-7.61 70.07,-11.32l0.04 0 0 0 10.78 -1.63 0.63 0 0 -0.09c6.99,-1.06 13.96,-2.12 21.07,-3.17l0.13 0 0 -0.01c11.13,-1.64 22.4,-3.27 33.82,-4.88l0.42 0 0 -0.06 11.36 -1.57 0.05 0 0 -0.01c27.9,-3.88 56.63,-7.68 86.23,-11.4l0.19 0 0 -0.03 12.88 -1.61 0.17 0 0 -0.01c22.23,-2.76 44.87,-5.47 68,-8.14l0.48 0 0 -0.05 13.9 -1.58 0.78 0 0 -0.08c19.17,-2.18 38.57,-4.33 58.33,-6.44l0.37 0 0 -0.04c10.18,-1.09 20.5,-2.15 30.83,-3.22l0.14 0 0 -0.01 15.71 -1.62 0.6 0 0 -0.06c16.04,-1.63 32.3,-3.24 48.7,-4.83l0.22 0 0 -0.02c11.23,-1.09 22.52,-2.17 33.92,-3.25l0.32 0 0 -0.02 17.25 -1.6 0.68 0 0 -0.07c17.71,-1.63 35.57,-3.24 53.66,-4.83l0.15 0 0 -0.01 18.75 -1.62 0.82 0 0 -0.07c25.57,-2.2 51.48,-4.35 77.78,-6.45l0.49 0 0 -0.04c42.31,-3.38 85.51,-6.63 129.62,-9.74l0.82 0 0 -0.06 22.77 -1.57 0.06 0 0 -0.01 23.61 -1.62 0.84 0 0 -0.06c16.11,-1.09 32.34,-2.15 48.66,-3.2l0.26 0 0 -0.02 25.56 -1.61 0.53 0 0 -0.04 25.68 -1.6 0.41 0 0 -0.02c27.31,-1.67 54.89,-3.29 82.77,-4.87l0.39 0 0 -0.02 29.18 -1.61 0.17 0 0 -0.01c20.3,-1.11 40.74,-2.19 61.33,-3.25l0.63 0 0 -0.03 31.64 -1.6 0.97 0 0 -0.04 32.21 -1.59 0.4 0 0 -0.02c23.42,-1.12 47.06,-2.19 70.82,-3.24l0.92 0 0 -0.04 36.55 -1.59 0.96 0 0 -0.05c12.74,-0.54 25.52,-1.06 38.34,-1.58l0.79 0 0 -0.03c27.92,-1.13 56.1,-2.2 84.43,-3.23l1.99 0 0 -0.08c30.81,-1.12 61.85,-2.18 93.14,-3.18l1.43 0 0 -0.05c17.1,-0.54 34.27,-1.07 51.51,-1.58l0.67 0 0 -0.02c18.85,-0.56 37.79,-1.1 56.81,-1.62l0.26 0 0 0c20.93,-0.57 41.97,-1.11 63.09,-1.63l2.13 0 0 -0.05c22.9,-0.56 45.91,-1.08 69.03,-1.58l1.09 0 0 -0.02c27.06,-0.58 54.27,-1.12 81.62,-1.61l1.53 0 0 -0.02c33.37,-0.6 66.92,-1.15 100.68,-1.61l6.94 0 0 -0.09c48.74,-0.66 97.91,-1.16 147.41,-1.54l9.12 0 0 -0.07c61.25,-0.44 123.04,-0.68 185.33,-0.68 62.67,0 124.82,0.24 186.44,0.69l0 0.06 8.01 0c49.88,0.38 99.41,0.89 148.52,1.56l0 0.07 5.82 0c33.6,0.46 66.96,1 100.17,1.6l0 0.03 2.05 0c27.17,0.49 54.21,1.02 81.11,1.59l0 0.04 1.6 0c22.94,0.49 45.77,1.01 68.51,1.57l0 0.06 2.64 0c20.95,0.52 41.81,1.05 62.58,1.62l0 0.01 0.78 0c18.83,0.52 37.6,1.05 56.29,1.6l0 0.04 1.19 0c17.06,0.5 34.05,1.03 50.99,1.57l0 0.06 1.94 0c31.67,1.01 63.08,2.09 94.26,3.22l0 0.04 0.87 0c14.44,0.52 28.82,1.06 43.15,1.61l0 0.02 0.49 0c26.65,1.02 53.14,2.09 79.41,3.2l0 0.06 1.48 0 36.02 1.56 0 0.07 1.45 0c23.58,1.04 47.05,2.11 70.3,3.22l0 0.04 0.91 0 31.7 1.56 0 0.07 1.48 0c31.35,1.56 62.38,3.18 93.09,4.86l0 0.03 0.68 0 28.67 1.58 0 0.05 0.9 0c27.7,1.57 55.11,3.18 82.26,4.84l0 0.05 0.92 0 25.17 1.57 0 0.07 1.04 0 25.05 1.58 0 0.05 0.77 0c24.46,1.57 48.63,3.2 72.6,4.85l0 0.04 0.57 0c37.93,2.62 75.29,5.33 111.94,8.14l0 0.01 0.18 0c27.51,2.11 54.6,4.28 81.35,6.5l0 0.02 0.3 0 19.27 1.62 0 0.01 0.23 0c12.5,1.06 24.94,2.12 37.26,3.2l0 0.06 0.67 0c24.04,2.11 47.72,4.25 71.08,6.45l0 0.07 0.83 0 17.11 1.62 0 0.02 0.12 0c27.63,2.63 54.77,5.33 81.4,8.08l0 0.07 0.65 0c40.68,4.21 80.15,8.55 118.38,13.01l0 0.03 0.25 0c9.22,1.08 18.4,2.16 27.47,3.25l0 0.02 0.16 0 12.89 1.57 0 0.06 0.44 0 12.6 1.54 0 0.08 0.68 0 12.37 1.55 0 0.09 0.7 0 12.34 1.57 0 0.06 0.45 0 12.59 1.6 0 0.03 0.21 0c16.53,2.14 32.73,4.31 48.71,6.5l0 0.02 0.18 0 11.24 1.55 0 0.08 0.56 0c19.25,2.68 38.08,5.4 56.5,8.14l0 0.01 0.06 0c7.08,1.06 14.18,2.11 21.14,3.18l0 0.08 0.54 0c6.98,1.08 13.81,2.16 20.66,3.24l0 0.03 0.16 0c33.56,5.29 65.62,10.72 96.04,16.26l0 0.04 0.23 0c8.76,1.6 17.36,3.2 25.86,4.82l0 0.07 0.4 0c19.61,3.74 38.52,7.52 56.67,11.36l0 0.06 0.29 0c7.64,1.61 15.16,3.24 22.54,4.87l0 0.02 0.09 0c16.99,3.75 33.26,7.56 48.82,11.41l0 0 0.02 0c13.03,3.22 25.48,6.48 37.49,9.75l0 0.04 0.12 0c3.83,1.05 7.57,2.1 11.29,3.15l0 0.11 0.38 0c9.45,2.67 18.57,5.36 27.34,8.07l0 0.08 0.25 0 4.64 1.43 0 0.2 0.62 0c11.89,3.75 23.09,7.53 33.62,11.35l0 0.06 0.16 0c4.43,1.61 8.7,3.22 12.89,4.84l0 0.06 0.15 0 1.58 0.59 -2.76 1.03 -0.6 0 0 0.23c-2.65,1.02 -5.36,2.03 -8.1,3.04l-0.06 0 0 0.02c-20.99,7.74 -44.8,15.35 -71.29,22.81l-0.45 0 0 0.12c-3.72,1.05 -7.49,2.09 -11.31,3.13l-0.11 0 0 0.03c-20.25,5.51 -41.95,10.94 -65.09,16.28l-0.13 0 0 0.03c-9.44,2.18 -19.15,4.34 -29.07,6.49l-0.28 0 0 0.06c-7.47,1.62 -15.06,3.23 -22.78,4.84l-0.05 0 0 0.01c-10.55,2.18 -21.36,4.35 -32.4,6.51l-0.2 0 0 0.04 -8.1 1.59 -0.06 0 0 0c-8.51,1.64 -17.18,3.27 -25.96,4.89l-0.13 0 0 0.02c-17.88,3.3 -36.36,6.55 -55.36,9.76l-0.07 0 0 0.01 -9.58 1.62 -0.21 0 0 0.04 -9.76 1.59 -0.02 0 0 0.01c-23.54,3.86 -47.86,7.67 -72.98,11.41l-0.39 0 0 0.06c-18.4,2.73 -37.24,5.43 -56.46,8.09l-0.62 0 0 0.09 -11.18 1.54 -0.23 0 0 0.03c-20.13,2.75 -40.73,5.46 -61.73,8.12l-0.23 0 0 0.04 -12.57 1.59 -0.48 0 0 0.07 -12.73 1.57 -0.31 0 0 0.03 -12.99 1.59 -0.05 0 0 0.01c-18.08,2.2 -36.41,4.38 -55.07,6.52l-0.37 0 0 0.04 -14.06 1.59 -0.62 0 0 0.07c-24.32,2.74 -49.12,5.44 -74.38,8.08l-0.62 0 0 0.06c-15.58,1.63 -31.33,3.24 -47.26,4.83l-0.03 0 0 0c-16.54,1.65 -33.22,3.29 -50.13,4.89l-0.41 0 0 0.05c-29.19,2.77 -58.89,5.47 -89.15,8.11l-0.54 0 0 0.04c-31.93,2.79 -64.5,5.48 -97.58,8.11l-0.25 0 0 0.02 -20.44 1.61 -0.76 0 0 0.06 -20.37 1.57 -0.82 0 0 0.06 -20.81 1.57 -0.39 0 0 0.03c-29.79,2.23 -59.99,4.39 -90.62,6.49l-0.69 0 0 0.05c-24.1,1.65 -48.45,3.27 -73.05,4.84l-0.32 0 0 0.02 -25.53 1.61 -0.57 0 0 0.04 -25.99 1.6 -0.09 0 0 0c-18.21,1.11 -36.55,2.19 -55.01,3.25l-0.43 0 0 0.03 -28.07 1.61 -1.28 0 0 0.07 -28.61 1.56 -0.74 0 0 0.04c-20.28,1.1 -40.66,2.18 -61.21,3.22l-0.75 0 0 0.04 -31.99 1.59 -0.62 0 0 0.03 -33.06 1.6 -1.18 0 0 0.06c-23.35,1.1 -46.88,2.17 -70.55,3.2l-1.2 0 0 0.05 -36.81 1.58 -0.69 0 0 0.03c-26.79,1.12 -53.74,2.2 -80.92,3.23l-0.61 0 0 0.03c-14.53,0.55 -29.14,1.08 -43.78,1.6l-1.88 0 0 0.07c-31.47,1.13 -63.21,2.19 -95.17,3.19l-1.03 0 0 0.04c-17.61,0.55 -35.29,1.08 -53.05,1.59l-0.76 0 0 0.03c-19.26,0.56 -38.61,1.09 -58.04,1.61l-0.66 0 0 0.01c-21.36,0.57 -42.8,1.1 -64.35,1.62l-0.87 0 0 0.02c-24.09,0.57 -48.29,1.11 -72.62,1.6l-2.38 0 0 0.05c-64.89,1.33 -130.63,2.4 -197.05,3.22l-3.51 0 0 0.04c-61.21,0.75 -123.02,1.28 -185.38,1.59l-10.28 0 0 0.05c-38.04,0.18 -76.28,0.26 -114.7,0.26 -38.05,0 -75.91,-0.09 -113.58,-0.25z",
    style: {
      fill: "rgb(145, 52, 43)"
    },
    transform: "matrix(0.8999318877517442, 0, 0, 0.8999318877517442, 1698.1033974632992, 1162.4061017214049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10 area_cor_interna_3_camada_5",
    d: "M16641.28 11834.1l0 -0.06 -12.14 0c-62.29,-0.31 -124.02,-0.84 -185.16,-1.59l0 -0.04 -3.83 0c-65.77,-0.82 -130.83,-1.89 -195.1,-3.2l0 -0.07 -3.3 0c-24.01,-0.49 -47.92,-1.02 -71.7,-1.58l0 -0.04 -1.95 0c-21.19,-0.5 -42.28,-1.03 -63.27,-1.58l0 -0.05 -1.9 0c-19.56,-0.52 -39.04,-1.06 -58.43,-1.63l0 -0.01 -0.36 0c-17.34,-0.5 -34.62,-1.03 -51.82,-1.56l0 -0.07 -2.13 0c-32.15,-1.01 -64.06,-2.08 -95.71,-3.21l0 -0.05 -1.21 0c-14.33,-0.51 -28.59,-1.04 -42.81,-1.58l0 -0.05 -1.38 0c-27.46,-1.04 -54.72,-2.13 -81.78,-3.26l-0.03 0 -37.47 -1.6 0 -0.03 -0.54 0c-23.9,-1.05 -47.64,-2.13 -71.2,-3.24l0 -0.02 -0.44 0c-42.52,-2.02 -84.48,-4.14 -125.86,-6.38l0.46 -0.14 0.28 0 0 -0.09c12.03,-3.85 25.6,-7.63 40.56,-11.32l0.21 0 0 -0.05 6.48 -1.59 0.04 0 0 0c9.23,-2.21 18.97,-4.38 29.2,-6.52l0.15 0 0 -0.03c7.85,-1.64 15.98,-3.26 24.4,-4.86l0.06 0 0 -0.01c39.59,-7.53 85.48,-14.62 136.79,-21.19l0.17 0 0 -0.02 12.76 -1.61 0.29 0 0 -0.04 13 -1.59 0.04 0 0 0c38.58,-4.64 79.97,-9 123.89,-13.04l0.03 0 0 -0.01 17.93 -1.62 0.01 0c19.03,-1.69 38.5,-3.33 58.42,-4.9l0.28 0 0 -0.02 20.8 -1.6 0.4 0 0 -0.03c30.53,-2.31 62.03,-4.48 94.4,-6.5l0.17 0 0 -0.01c18.09,-1.13 36.45,-2.21 55.08,-3.25l0.36 0 0 -0.02c31.82,-1.76 64.42,-3.39 97.71,-4.87l0.12 0 0 0c26.5,-1.18 53.42,-2.27 80.77,-3.26l0.76 0 0 -0.03c15.72,-0.57 31.59,-1.1 47.57,-1.6l1.34 0 0 -0.04c41.43,-1.3 83.73,-2.38 126.76,-3.22l2.06 0 0 -0.04c35.52,-0.69 71.56,-1.22 108.02,-1.59l1.23 0 0 -0.02c39.55,-0.39 79.59,-0.6 120.1,-0.6 40.33,0 80.21,0.21 119.59,0.6l0 0.02 1.73 0c36.86,0.37 73.26,0.91 109.14,1.61l0 0.02 0.95 0c23.83,0.47 47.43,1.01 70.8,1.62l0 0.01 0.34 0c19.07,0.49 37.99,1.03 56.73,1.62l0 0.01 0.22 0c43.88,1.37 86.77,3.01 128.59,4.86l0 0.03 0.63 0c11.83,0.53 23.6,1.07 35.24,1.63l0.03 0c66.77,3.22 130.53,7.05 190.75,11.41l0 0 0.06 0c48,3.48 93.72,7.29 136.9,11.42 11.04,1.05 21.91,2.13 32.61,3.22l0 0.04 0.39 0c15.45,1.58 30.55,3.2 45.27,4.86l0 0.03 0.27 0c89.22,10.07 164.67,21.6 223.11,34.21l0 0.03 0.16 0c4.96,1.07 9.8,2.14 14.52,3.23l0 0.03 0.13 0c20.81,4.8 39.18,9.75 54.94,14.82 -19.7,1.06 -39.54,2.11 -59.5,3.12l-0.46 0 0 0.02 -32.13 1.61 -0.48 0 0 0.02 -33.29 1.61 -0.95 0 0 0.05c-23.4,1.11 -46.96,2.18 -70.69,3.21l-1.06 0 0 0.05 -36.95 1.58 -0.55 0 0 0.02c-26.89,1.13 -53.98,2.2 -81.26,3.24l-0.27 0 0 0.01c-14.58,0.56 -29.22,1.1 -43.92,1.62l-1.74 0 0 0.06c-31.48,1.13 -63.21,2.2 -95.18,3.2l-1.02 0 0 0.04c-17.57,0.55 -35.21,1.08 -52.93,1.59l-0.88 0 0 0.03c-19.22,0.56 -38.52,1.09 -57.91,1.61l-0.79 0 0 0.02c-21.36,0.56 -42.82,1.09 -64.38,1.61l-0.84 0 0 0.02c-24.15,0.56 -48.42,1.1 -72.81,1.6l-2.19 0 0 0.05c-64.63,1.32 -130.06,2.4 -196.21,3.22l-4.35 0 0 0.05c-60.96,0.75 -122.53,1.27 -184.64,1.58l-11.02 0 0 0.05c-38.04,0.18 -76.28,0.26 -114.7,0.26 -38.05,0 -75.91,-0.09 -113.58,-0.25z",
    style: {
      fill: "rgb(237, 50, 56)"
    },
    transform: "matrix(1, 0, 0, 1, 0, -24.876874681341633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14673.2001953125 12180.2998046875 L 14738.099609375 12526.8603515625 L 14943.509765625 12321.4404296875 Z",
    className: "fil4 area_cor_fonte_camada_5",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18714.029296875 12208.900390625 L 18677.919921875 12526.8603515625 L 18472.5 12321.4404296875 Z",
    className: "fil4 area_cor_fonte_camada_5",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 17004.04,
    y: 12605.54,
    className: "fil4 fnt1 botao camada_5 area_cor_fonte_camada_5 label_camada_5",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "322.89px",
      fontFamily: "'Arial'",
      fontWeight: "Arial",
      textAnchor: "middle"
    },
    transform: "matrix(1.089464545249939, 0, 0, 1.089464545249939, -1804.0626220703125, -1196.1141389507632)"
  }, "N\xEDvel 5"), /*#__PURE__*/React.createElement("path", {
    className: "fil3 camada_5 botao area_fundo_circulo_camada_5",
    d: "M21743.99 12015.68c0,336.11 -272.46,608.57 -608.57,608.57 -336.08,0 -608.55,-272.46 -608.55,-608.57 0,-336.11 272.47,-608.58 608.55,-608.58 336.11,0 608.57,272.47 608.57,608.58z",
    style: {
      fill: "rgb(171, 49, 45)"
    },
    transform: "matrix(1.1294000672242652, 0, 0, 1.1294000672242652, -2699.1324883869356, -1519.0343592209258)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    transform: "matrix(1.0991940712558939, 0, 0, 1.0991940712558939, -2236.978262212132, -1225.2746982950885)",
    x: 20750,
    y: 11811
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 21280,
    dy: 340,
    className: "label camada_5 area_cor_fonte_camada_5"
  }, "0")), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    transform: "matrix(1.0164466480663978, 0, 0, 1.0164466480663978, -317.2807138158479, -181.68899443224632)",
    x: 11900,
    y: 11811
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 12480,
    dy: 290,
    className: "label camada_5 area_cor_fonte_camada_5"
  }, "0")), /*#__PURE__*/React.createElement("path", {
    d: "M 23331.9765625 12207.056640625",
    style: {
      fill: "rgb(241, 95, 74)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14431.673828125 12003.2451171875 L 14431.673828125 12003.2451171875",
    style: {
      fill: "rgb(132, 37, 43)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    },
    transform: "matrix(0.9244342200451858, 0, 0, 0.9244342200451858, 1287.571978992618, 913.9432319909197)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil7 area_cor_interna_3_camada_2",
    d: "M16543.7 6066.01l0 -0.1 -19.94 0c-102.37,-0.5 -203.82,-1.37 -304.29,-2.6l0 -0.08 -6.31 0c-108.08,-1.33 -214.99,-3.1 -320.61,-5.25l0 -0.11 -5.44 0c-39.45,-0.81 -78.74,-1.68 -117.83,-2.6l0 -0.07 -3.2 0c-34.81,-0.82 -69.47,-1.7 -103.98,-2.6l0 -0.08 -3.12 0c-32.15,-0.86 -64.16,-1.74 -96.03,-2.67l0 -0.02 -0.59 0c-28.5,-0.82 -56.88,-1.69 -85.16,-2.57l0 -0.11 -3.5 0c-52.83,-1.66 -105.27,-3.42 -157.28,-5.28l0 -0.07 -2 0c-23.54,-0.85 -46.99,-1.71 -70.35,-2.6l0 -0.08 -2.27 0c-45.12,-1.72 -89.92,-3.51 -134.39,-5.37l-0.05 0 -61.58 -2.63 0 -0.04 -0.89 0c-39.28,-1.72 -78.29,-3.5 -117.02,-5.33l0 -0.03 -0.71 0c-69.88,-3.31 -138.84,-6.81 -206.83,-10.48l0.75 -0.24 0.46 0 0 -0.14c19.77,-6.34 42.06,-12.55 66.65,-18.61l0.34 0 0 -0.09 10.66 -2.6 0.06 0 0 -0.01c15.17,-3.62 31.17,-7.19 47.99,-10.7l0.24 0 0 -0.06c12.9,-2.69 26.27,-5.36 40.11,-7.99l0.09 0 0 -0.01c65.07,-12.38 140.47,-24.02 224.81,-34.82l0.28 0 0 -0.04 20.96 -2.64 0.48 0 0 -0.06 21.36 -2.62 0.07 0 0 0c63.4,-7.63 131.42,-14.79 203.6,-21.44l0.06 0 0 -0.01 29.46 -2.66 0.01 0c31.27,-2.78 63.28,-5.47 96,-8.05l0.47 0 0 -0.04 34.18 -2.63 0.66 0 0 -0.05c50.17,-3.79 101.93,-7.36 155.14,-10.68l0.28 0 0 -0.01c29.73,-1.86 59.9,-3.64 90.52,-5.34l0.58 0 0 -0.03c52.3,-2.9 105.88,-5.58 160.58,-8.01l0.2 0 0 -0.01c43.55,-1.93 87.79,-3.73 132.73,-5.35l1.26 0 0 -0.05c25.84,-0.93 51.91,-1.81 78.18,-2.63l2.2 0 0 -0.07c68.08,-2.14 137.59,-3.9 208.31,-5.29l3.38 0 0 -0.06c58.38,-1.14 117.61,-2.01 177.53,-2.62l2.01 0 0 -0.02c65,-0.66 130.81,-1 197.38,-1 66.28,0 131.81,0.34 196.53,0.99l0 0.03 2.86 0c60.56,0.62 120.39,1.5 179.36,2.65l0 0.03 1.55 0c39.17,0.77 77.95,1.66 116.35,2.66l0 0.02 0.56 0c31.34,0.82 62.44,1.69 93.23,2.66l0 0.02 0.37 0c72.11,2.26 142.6,4.94 211.32,8l0 0.04 1.04 0c19.43,0.87 38.77,1.76 57.91,2.68l0.04 0c109.74,5.3 214.52,11.59 313.48,18.75l0 0.01 0.11 0c78.87,5.71 154.02,11.98 224.98,18.75 18.15,1.73 36.01,3.5 53.6,5.3l0 0.06 0.64 0c25.38,2.6 50.2,5.26 74.38,7.99l0 0.05 0.46 0c146.62,16.55 270.61,35.5 366.66,56.22l0 0.05 0.25 0c8.15,1.76 16.12,3.52 23.86,5.31l0 0.05 0.22 0c34.19,7.89 64.39,16.02 90.28,24.36 -32.37,1.74 -64.97,3.46 -97.77,5.12l-0.76 0 0 0.04 -52.8 2.64 -0.8 0 0 0.03 -54.7 2.65 -1.57 0 0 0.07c-38.45,1.83 -77.17,3.59 -116.16,5.29l-1.74 0 0 0.08 -60.73 2.59 -0.9 0 0 0.04c-44.19,1.86 -88.71,3.62 -133.55,5.33l-0.44 0 0 0.01c-23.96,0.91 -48.03,1.8 -72.17,2.67l-2.86 0 0 0.1c-51.74,1.85 -103.88,3.6 -156.42,5.25l-1.68 0 0 0.06c-28.88,0.9 -57.87,1.78 -86.99,2.62l-1.44 0 0 0.04c-31.58,0.92 -63.31,1.8 -95.17,2.65l-1.3 0 0 0.03c-35.11,0.93 -70.37,1.8 -105.8,2.65l-1.38 0 0 0.03c-39.69,0.93 -79.58,1.81 -119.65,2.64l-3.61 0 0 0.08c-106.21,2.17 -213.74,3.94 -322.45,5.28l-7.15 0 0 0.09c-100.19,1.23 -201.37,2.09 -303.44,2.59l-18.12 0 0 0.09c-62.51,0.29 -125.34,0.42 -188.49,0.42 -62.53,0 -124.75,-0.14 -186.66,-0.41z",
    style: {
      fill: "rgb(18, 179, 109)"
    },
    transform: "matrix(0.09450215101242065, 0, 0, 0.10664401203393936, -1014.8607788085938, -351.3935546875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 917.4481201171875 297.43768310546875",
    style: {
      fill: "rgb(139, 204, 162)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    },
    transform: "matrix(1, 0, 0, 1, -192.26711463928223, 101.0765380859375)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08791036903858185, 0, 0, 0.08791036903858185, -911.1606654273045, -435.6226501464844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19094.01 12624.25l2105.35 0 0 -1217.15 -2067.33 0c190.04,40.39 297.2,86.1 297.2,134.54 0,0.11 0,0.22 0,0.33 -0.05,6.67 -2.17,13.32 -6.24,19.91l-328.98 1062.37zm335.22 -1082.61l0 0zm0 0.33l0 0z",
    style: {
      fill: "url('#gradient-58')"
    },
    transform: "matrix(0.9784837791909574, 0, 0, 0.9784837791909574, 420.386306943878, 284.72033637771847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M14339.71 12624.25l-2105.34 0 0 -1217.15 2067.33 0c-190.05,40.39 -297.21,86.1 -297.21,134.54 0,0.11 0,0.22 0,0.33 0.06,6.67 2.17,13.32 6.25,19.91l328.97 1062.37zm-335.22 -1082.61l0 0zm0 0.33l0 0z",
    style: {
      fill: "url('#gradient-59')"
    },
    transform: "matrix(0.9354518855957553, 0, 0, 0.9354518855957553, 1014.783348639372, 788.682967834761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 camada_4 botao area_fundo_circulo_camada_4",
    d: "M12906.85 12015.68c0,336.11 -272.46,608.57 -608.57,608.57 -336.09,0 -608.55,-272.46 -608.55,-608.57 0,-336.11 272.46,-608.58 608.55,-608.58 336.11,0 608.57,272.47 608.57,608.58z",
    style: {
      fill: "rgb(237, 50, 55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7 botao camada_4 area_cor_camada_4",
    d: "M19502.29 11536.01c0,-164.77 -1230.07,-298.35 -2747.43,-298.35 -1517.37,0 -2747.44,133.58 -2747.44,298.35 0,6.6 2.2,13.16 6.09,19.66l351.94 1136.53c0,0 -2.7,259.47 2305.77,259.47 2308.46,0 2473.03,-259.47 2473.03,-259.47l351.96 -1136.53c3.89,-6.5 6.08,-13.06 6.08,-19.66z",
    style: {
      fill: "url('#gradient-63')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8 area_cor_interna_1_camada_4",
    d: "M19502.29 11536.01c0,164.76 -1230.07,298.34 -2747.43,298.34 -1517.37,0 -2747.44,-133.58 -2747.44,-298.34 0,-164.77 1230.07,-298.35 2747.44,-298.35 1517.36,0 2747.43,133.58 2747.43,298.35z",
    style: {
      fill: "rgb(237, 50, 55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9 area_cor_interna_2_camada_4",
    d: "M16641.28 11834.1l0 -0.06 -11.4 0c-62.55,-0.31 -124.51,-0.85 -185.9,-1.59l0 -0.04 -2.99 0c-66.05,-0.82 -131.4,-1.88 -195.94,-3.2l0 -0.07 -3.5 0c-23.95,-0.49 -47.78,-1.02 -71.5,-1.58l0 -0.04 -1.98 0c-21.18,-0.5 -42.25,-1.03 -63.24,-1.59l0 -0.04 -1.78 0c-19.6,-0.52 -39.12,-1.06 -58.55,-1.63l0 -0.01 -0.25 0c-17.38,-0.5 -34.69,-1.02 -51.93,-1.56l0 -0.07 -2.15 0c-32.13,-1 -64.04,-2.07 -95.69,-3.2l0 -0.06 -1.36 0c-14.26,-0.51 -28.5,-1.02 -42.66,-1.56l0 -0.07 -1.73 0c-27.35,-1.03 -54.48,-2.12 -81.43,-3.25l0 -0.01 -0.17 0 -37.33 -1.6 0 -0.03 -0.68 0c-23.85,-1.04 -47.55,-2.11 -71.06,-3.23l0 -0.03 -0.68 0 -33.57 -1.63 0 0 -0.11 0c-10.86,-0.53 -21.72,-1.06 -32.5,-1.61l0 -0.02 -0.24 0c-20.73,-1.05 -41.28,-2.14 -61.72,-3.25l0 -0.01 -0.23 0 -29.12 -1.59 0 -0.04 -0.78 0c-37.21,-2.08 -73.89,-4.26 -110.1,-6.52l0 -0.01 -0.05 0c-33.6,-2.09 -66.72,-4.26 -99.41,-6.5l0 -0.02 -0.18 0 -22.65 -1.56 0 -0.07 -0.98 0c-29.98,-2.1 -59.54,-4.27 -88.7,-6.5l0 -0.02 -0.31 0 -20.88 -1.61 0 -0.02 -0.25 0c-33.66,-2.62 -66.72,-5.33 -99.22,-8.1l0 -0.05 -0.57 0 -19 -1.63 0 0 -0.03 0c-24.27,-2.12 -48.13,-4.29 -71.71,-6.49l0 -0.03 -0.42 0c-11.36,-1.06 -22.62,-2.13 -33.82,-3.22l0 -0.05 -0.51 0c-21.87,-2.11 -43.47,-4.25 -64.71,-6.44l0 -0.08 -0.79 0 -15.52 -1.62 0 -0.01 -0.11 0c-20.36,-2.13 -40.47,-4.28 -60.22,-6.48l0 -0.04 -0.36 0 -14.31 -1.62 0 -0.01 -0.11 0c-14.27,-1.61 -28.36,-3.24 -42.29,-4.89l0 0 -0.03 0c-48.85,-5.77 -95.61,-11.76 -140.19,-17.93l0 -0.01 -0.12 0 -11.3 -1.56 0 -0.07 -0.46 0c-22.72,-3.19 -44.86,-6.43 -66.39,-9.72l0 -0.06 -0.39 0c-7.03,-1.08 -13.91,-2.17 -20.81,-3.25l0 -0.02 -0.08 0c-40.27,-6.33 -78.3,-12.85 -114.06,-19.52l0 -0.04 -0.19 0c-25.59,-4.78 -50,-9.65 -73.18,-14.59l0 -0.09 -0.39 0c-15.05,-3.21 -29.63,-6.46 -43.64,-9.74l0 -0.04 -0.17 0 -6.35 -1.53 0 -0.1 -0.43 0c-15.79,-3.76 -30.84,-7.56 -45.23,-11.41l0 0 -0.03 0c-17.94,-4.8 -34.83,-9.65 -50.51,-14.56l0 -0.12 -0.37 0c-1.55,-0.48 -3,-0.98 -4.52,-1.46l0 -0.17 -0.51 0c-10.09,-3.23 -19.74,-6.48 -28.84,-9.75l0 -0.03 -0.09 0c-4.48,-1.61 -8.74,-3.23 -12.96,-4.86l0 -0.04 -0.09 0 -2.76 -1.03c1.9,-0.75 3.97,-1.49 5.92,-2.22l0.19 0 0 -0.07c10.08,-3.82 20.83,-7.6 32.25,-11.35l0.37 0 0 -0.12 4.64 -1.51 0.25 0 0 -0.08c1.61,-0.51 3.15,-1.04 4.78,-1.55l0.11 0 0 -0.03c12.13,-3.83 24.95,-7.63 38.46,-11.39l0.67 0 0 -0.19c3.7,-1.02 7.55,-2.04 11.35,-3.06l0.06 0 0 -0.02c16.36,-4.39 33.6,-8.74 51.79,-13.03l0.39 0 0 -0.09c11.51,-2.71 23.44,-5.4 35.67,-8.06l0.2 0 0 -0.05c7.46,-1.62 15.04,-3.24 22.77,-4.85l0.06 0 0 -0.01 7.84 -1.61 0.31 0 0 -0.07c10.59,-2.17 21.38,-4.32 32.43,-6.46l0.19 0 0 -0.04c8.43,-1.62 17.02,-3.24 25.72,-4.85l0.36 0 0 -0.07c11.73,-2.17 23.61,-4.32 35.82,-6.45l0.06 0 0 -0.01 9.48 -1.62 0.3 0 0 -0.05 9.25 -1.58 0.54 0 0 -0.1c22.61,-3.83 45.92,-7.61 70.07,-11.32l0.04 0 0 0 10.78 -1.63 0.63 0 0 -0.09c6.99,-1.06 13.96,-2.12 21.07,-3.17l0.13 0 0 -0.01c11.13,-1.64 22.4,-3.27 33.82,-4.88l0.42 0 0 -0.06 11.36 -1.57 0.05 0 0 -0.01c27.9,-3.88 56.63,-7.68 86.23,-11.4l0.19 0 0 -0.03 12.88 -1.61 0.17 0 0 -0.01c22.23,-2.76 44.87,-5.47 68,-8.14l0.48 0 0 -0.05 13.9 -1.58 0.78 0 0 -0.08c19.17,-2.18 38.57,-4.33 58.33,-6.44l0.37 0 0 -0.04c10.18,-1.09 20.5,-2.15 30.83,-3.22l0.14 0 0 -0.01 15.71 -1.62 0.6 0 0 -0.06c16.04,-1.63 32.3,-3.24 48.7,-4.83l0.22 0 0 -0.02c11.23,-1.09 22.52,-2.17 33.92,-3.25l0.32 0 0 -0.02 17.25 -1.6 0.68 0 0 -0.07c17.71,-1.63 35.57,-3.24 53.66,-4.83l0.15 0 0 -0.01 18.75 -1.62 0.82 0 0 -0.07c25.57,-2.2 51.48,-4.35 77.78,-6.45l0.49 0 0 -0.04c42.31,-3.38 85.51,-6.63 129.62,-9.74l0.82 0 0 -0.06 22.77 -1.57 0.06 0 0 -0.01 23.61 -1.62 0.84 0 0 -0.06c16.11,-1.09 32.34,-2.15 48.66,-3.2l0.26 0 0 -0.02 25.56 -1.61 0.53 0 0 -0.04 25.68 -1.6 0.41 0 0 -0.02c27.31,-1.67 54.89,-3.29 82.77,-4.87l0.39 0 0 -0.02 29.18 -1.61 0.17 0 0 -0.01c20.3,-1.11 40.74,-2.19 61.33,-3.25l0.63 0 0 -0.03 31.64 -1.6 0.97 0 0 -0.04 32.21 -1.59 0.4 0 0 -0.02c23.42,-1.12 47.06,-2.19 70.82,-3.24l0.92 0 0 -0.04 36.55 -1.59 0.96 0 0 -0.05c12.74,-0.54 25.52,-1.06 38.34,-1.58l0.79 0 0 -0.03c27.92,-1.13 56.1,-2.2 84.43,-3.23l1.99 0 0 -0.08c30.81,-1.12 61.85,-2.18 93.14,-3.18l1.43 0 0 -0.05c17.1,-0.54 34.27,-1.07 51.51,-1.58l0.67 0 0 -0.02c18.85,-0.56 37.79,-1.1 56.81,-1.62l0.26 0 0 0c20.93,-0.57 41.97,-1.11 63.09,-1.63l2.13 0 0 -0.05c22.9,-0.56 45.91,-1.08 69.03,-1.58l1.09 0 0 -0.02c27.06,-0.58 54.27,-1.12 81.62,-1.61l1.53 0 0 -0.02c33.37,-0.6 66.92,-1.15 100.68,-1.61l6.94 0 0 -0.09c48.74,-0.66 97.91,-1.16 147.41,-1.54l9.12 0 0 -0.07c61.25,-0.44 123.04,-0.68 185.33,-0.68 62.67,0 124.82,0.24 186.44,0.69l0 0.06 8.01 0c49.88,0.38 99.41,0.89 148.52,1.56l0 0.07 5.82 0c33.6,0.46 66.96,1 100.17,1.6l0 0.03 2.05 0c27.17,0.49 54.21,1.02 81.11,1.59l0 0.04 1.6 0c22.94,0.49 45.77,1.01 68.51,1.57l0 0.06 2.64 0c20.95,0.52 41.81,1.05 62.58,1.62l0 0.01 0.78 0c18.83,0.52 37.6,1.05 56.29,1.6l0 0.04 1.19 0c17.06,0.5 34.05,1.03 50.99,1.57l0 0.06 1.94 0c31.67,1.01 63.08,2.09 94.26,3.22l0 0.04 0.87 0c14.44,0.52 28.82,1.06 43.15,1.61l0 0.02 0.49 0c26.65,1.02 53.14,2.09 79.41,3.2l0 0.06 1.48 0 36.02 1.56 0 0.07 1.45 0c23.58,1.04 47.05,2.11 70.3,3.22l0 0.04 0.91 0 31.7 1.56 0 0.07 1.48 0c31.35,1.56 62.38,3.18 93.09,4.86l0 0.03 0.68 0 28.67 1.58 0 0.05 0.9 0c27.7,1.57 55.11,3.18 82.26,4.84l0 0.05 0.92 0 25.17 1.57 0 0.07 1.04 0 25.05 1.58 0 0.05 0.77 0c24.46,1.57 48.63,3.2 72.6,4.85l0 0.04 0.57 0c37.93,2.62 75.29,5.33 111.94,8.14l0 0.01 0.18 0c27.51,2.11 54.6,4.28 81.35,6.5l0 0.02 0.3 0 19.27 1.62 0 0.01 0.23 0c12.5,1.06 24.94,2.12 37.26,3.2l0 0.06 0.67 0c24.04,2.11 47.72,4.25 71.08,6.45l0 0.07 0.83 0 17.11 1.62 0 0.02 0.12 0c27.63,2.63 54.77,5.33 81.4,8.08l0 0.07 0.65 0c40.68,4.21 80.15,8.55 118.38,13.01l0 0.03 0.25 0c9.22,1.08 18.4,2.16 27.47,3.25l0 0.02 0.16 0 12.89 1.57 0 0.06 0.44 0 12.6 1.54 0 0.08 0.68 0 12.37 1.55 0 0.09 0.7 0 12.34 1.57 0 0.06 0.45 0 12.59 1.6 0 0.03 0.21 0c16.53,2.14 32.73,4.31 48.71,6.5l0 0.02 0.18 0 11.24 1.55 0 0.08 0.56 0c19.25,2.68 38.08,5.4 56.5,8.14l0 0.01 0.06 0c7.08,1.06 14.18,2.11 21.14,3.18l0 0.08 0.54 0c6.98,1.08 13.81,2.16 20.66,3.24l0 0.03 0.16 0c33.56,5.29 65.62,10.72 96.04,16.26l0 0.04 0.23 0c8.76,1.6 17.36,3.2 25.86,4.82l0 0.07 0.4 0c19.61,3.74 38.52,7.52 56.67,11.36l0 0.06 0.29 0c7.64,1.61 15.16,3.24 22.54,4.87l0 0.02 0.09 0c16.99,3.75 33.26,7.56 48.82,11.41l0 0 0.02 0c13.03,3.22 25.48,6.48 37.49,9.75l0 0.04 0.12 0c3.83,1.05 7.57,2.1 11.29,3.15l0 0.11 0.38 0c9.45,2.67 18.57,5.36 27.34,8.07l0 0.08 0.25 0 4.64 1.43 0 0.2 0.62 0c11.89,3.75 23.09,7.53 33.62,11.35l0 0.06 0.16 0c4.43,1.61 8.7,3.22 12.89,4.84l0 0.06 0.15 0 1.58 0.59 -2.76 1.03 -0.6 0 0 0.23c-2.65,1.02 -5.36,2.03 -8.1,3.04l-0.06 0 0 0.02c-20.99,7.74 -44.8,15.35 -71.29,22.81l-0.45 0 0 0.12c-3.72,1.05 -7.49,2.09 -11.31,3.13l-0.11 0 0 0.03c-20.25,5.51 -41.95,10.94 -65.09,16.28l-0.13 0 0 0.03c-9.44,2.18 -19.15,4.34 -29.07,6.49l-0.28 0 0 0.06c-7.47,1.62 -15.06,3.23 -22.78,4.84l-0.05 0 0 0.01c-10.55,2.18 -21.36,4.35 -32.4,6.51l-0.2 0 0 0.04 -8.1 1.59 -0.06 0 0 0c-8.51,1.64 -17.18,3.27 -25.96,4.89l-0.13 0 0 0.02c-17.88,3.3 -36.36,6.55 -55.36,9.76l-0.07 0 0 0.01 -9.58 1.62 -0.21 0 0 0.04 -9.76 1.59 -0.02 0 0 0.01c-23.54,3.86 -47.86,7.67 -72.98,11.41l-0.39 0 0 0.06c-18.4,2.73 -37.24,5.43 -56.46,8.09l-0.62 0 0 0.09 -11.18 1.54 -0.23 0 0 0.03c-20.13,2.75 -40.73,5.46 -61.73,8.12l-0.23 0 0 0.04 -12.57 1.59 -0.48 0 0 0.07 -12.73 1.57 -0.31 0 0 0.03 -12.99 1.59 -0.05 0 0 0.01c-18.08,2.2 -36.41,4.38 -55.07,6.52l-0.37 0 0 0.04 -14.06 1.59 -0.62 0 0 0.07c-24.32,2.74 -49.12,5.44 -74.38,8.08l-0.62 0 0 0.06c-15.58,1.63 -31.33,3.24 -47.26,4.83l-0.03 0 0 0c-16.54,1.65 -33.22,3.29 -50.13,4.89l-0.41 0 0 0.05c-29.19,2.77 -58.89,5.47 -89.15,8.11l-0.54 0 0 0.04c-31.93,2.79 -64.5,5.48 -97.58,8.11l-0.25 0 0 0.02 -20.44 1.61 -0.76 0 0 0.06 -20.37 1.57 -0.82 0 0 0.06 -20.81 1.57 -0.39 0 0 0.03c-29.79,2.23 -59.99,4.39 -90.62,6.49l-0.69 0 0 0.05c-24.1,1.65 -48.45,3.27 -73.05,4.84l-0.32 0 0 0.02 -25.53 1.61 -0.57 0 0 0.04 -25.99 1.6 -0.09 0 0 0c-18.21,1.11 -36.55,2.19 -55.01,3.25l-0.43 0 0 0.03 -28.07 1.61 -1.28 0 0 0.07 -28.61 1.56 -0.74 0 0 0.04c-20.28,1.1 -40.66,2.18 -61.21,3.22l-0.75 0 0 0.04 -31.99 1.59 -0.62 0 0 0.03 -33.06 1.6 -1.18 0 0 0.06c-23.35,1.1 -46.88,2.17 -70.55,3.2l-1.2 0 0 0.05 -36.81 1.58 -0.69 0 0 0.03c-26.79,1.12 -53.74,2.2 -80.92,3.23l-0.61 0 0 0.03c-14.53,0.55 -29.14,1.08 -43.78,1.6l-1.88 0 0 0.07c-31.47,1.13 -63.21,2.19 -95.17,3.19l-1.03 0 0 0.04c-17.61,0.55 -35.29,1.08 -53.05,1.59l-0.76 0 0 0.03c-19.26,0.56 -38.61,1.09 -58.04,1.61l-0.66 0 0 0.01c-21.36,0.57 -42.8,1.1 -64.35,1.62l-0.87 0 0 0.02c-24.09,0.57 -48.29,1.11 -72.62,1.6l-2.38 0 0 0.05c-64.89,1.33 -130.63,2.4 -197.05,3.22l-3.51 0 0 0.04c-61.21,0.75 -123.02,1.28 -185.38,1.59l-10.28 0 0 0.05c-38.04,0.18 -76.28,0.26 -114.7,0.26 -38.05,0 -75.91,-0.09 -113.58,-0.25z",
    style: {
      fill: "rgb(241, 95, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10 area_cor_interna_3_camada_4",
    d: "M16641.28 11834.1l0 -0.06 -12.14 0c-62.29,-0.31 -124.02,-0.84 -185.16,-1.59l0 -0.04 -3.83 0c-65.77,-0.82 -130.83,-1.89 -195.1,-3.2l0 -0.07 -3.3 0c-24.01,-0.49 -47.92,-1.02 -71.7,-1.58l0 -0.04 -1.95 0c-21.19,-0.5 -42.28,-1.03 -63.27,-1.58l0 -0.05 -1.9 0c-19.56,-0.52 -39.04,-1.06 -58.43,-1.63l0 -0.01 -0.36 0c-17.34,-0.5 -34.62,-1.03 -51.82,-1.56l0 -0.07 -2.13 0c-32.15,-1.01 -64.06,-2.08 -95.71,-3.21l0 -0.05 -1.21 0c-14.33,-0.51 -28.59,-1.04 -42.81,-1.58l0 -0.05 -1.38 0c-27.46,-1.04 -54.72,-2.13 -81.78,-3.26l-0.03 0 -37.47 -1.6 0 -0.03 -0.54 0c-23.9,-1.05 -47.64,-2.13 -71.2,-3.24l0 -0.02 -0.44 0c-42.52,-2.02 -84.48,-4.14 -125.86,-6.38l0.46 -0.14 0.28 0 0 -0.09c12.03,-3.85 25.6,-7.63 40.56,-11.32l0.21 0 0 -0.05 6.48 -1.59 0.04 0 0 0c9.23,-2.21 18.97,-4.38 29.2,-6.52l0.15 0 0 -0.03c7.85,-1.64 15.98,-3.26 24.4,-4.86l0.06 0 0 -0.01c39.59,-7.53 85.48,-14.62 136.79,-21.19l0.17 0 0 -0.02 12.76 -1.61 0.29 0 0 -0.04 13 -1.59 0.04 0 0 0c38.58,-4.64 79.97,-9 123.89,-13.04l0.03 0 0 -0.01 17.93 -1.62 0.01 0c19.03,-1.69 38.5,-3.33 58.42,-4.9l0.28 0 0 -0.02 20.8 -1.6 0.4 0 0 -0.03c30.53,-2.31 62.03,-4.48 94.4,-6.5l0.17 0 0 -0.01c18.09,-1.13 36.45,-2.21 55.08,-3.25l0.36 0 0 -0.02c31.82,-1.76 64.42,-3.39 97.71,-4.87l0.12 0 0 0c26.5,-1.18 53.42,-2.27 80.77,-3.26l0.76 0 0 -0.03c15.72,-0.57 31.59,-1.1 47.57,-1.6l1.34 0 0 -0.04c41.43,-1.3 83.73,-2.38 126.76,-3.22l2.06 0 0 -0.04c35.52,-0.69 71.56,-1.22 108.02,-1.59l1.23 0 0 -0.02c39.55,-0.39 79.59,-0.6 120.1,-0.6 40.33,0 80.21,0.21 119.59,0.6l0 0.02 1.73 0c36.86,0.37 73.26,0.91 109.14,1.61l0 0.02 0.95 0c23.83,0.47 47.43,1.01 70.8,1.62l0 0.01 0.34 0c19.07,0.49 37.99,1.03 56.73,1.62l0 0.01 0.22 0c43.88,1.37 86.77,3.01 128.59,4.86l0 0.03 0.63 0c11.83,0.53 23.6,1.07 35.24,1.63l0.03 0c66.77,3.22 130.53,7.05 190.75,11.41l0 0 0.06 0c48,3.48 93.72,7.29 136.9,11.42 11.04,1.05 21.91,2.13 32.61,3.22l0 0.04 0.39 0c15.45,1.58 30.55,3.2 45.27,4.86l0 0.03 0.27 0c89.22,10.07 164.67,21.6 223.11,34.21l0 0.03 0.16 0c4.96,1.07 9.8,2.14 14.52,3.23l0 0.03 0.13 0c20.81,4.8 39.18,9.75 54.94,14.82 -19.7,1.06 -39.54,2.11 -59.5,3.12l-0.46 0 0 0.02 -32.13 1.61 -0.48 0 0 0.02 -33.29 1.61 -0.95 0 0 0.05c-23.4,1.11 -46.96,2.18 -70.69,3.21l-1.06 0 0 0.05 -36.95 1.58 -0.55 0 0 0.02c-26.89,1.13 -53.98,2.2 -81.26,3.24l-0.27 0 0 0.01c-14.58,0.56 -29.22,1.1 -43.92,1.62l-1.74 0 0 0.06c-31.48,1.13 -63.21,2.2 -95.18,3.2l-1.02 0 0 0.04c-17.57,0.55 -35.21,1.08 -52.93,1.59l-0.88 0 0 0.03c-19.22,0.56 -38.52,1.09 -57.91,1.61l-0.79 0 0 0.02c-21.36,0.56 -42.82,1.09 -64.38,1.61l-0.84 0 0 0.02c-24.15,0.56 -48.42,1.1 -72.81,1.6l-2.19 0 0 0.05c-64.63,1.32 -130.06,2.4 -196.21,3.22l-4.35 0 0 0.05c-60.96,0.75 -122.53,1.27 -184.64,1.58l-11.02 0 0 0.05c-38.04,0.18 -76.28,0.26 -114.7,0.26 -38.05,0 -75.91,-0.09 -113.58,-0.25z",
    style: {
      fill: "rgb(255, 120, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14673.2001953125 12180.2998046875 L 14738.099609375 12526.8603515625 L 14943.509765625 12321.4404296875 Z",
    className: "fil4 area_cor_fonte_camada_4",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18714.029296875 12208.900390625 L 18677.919921875 12526.8603515625 L 18472.5 12321.4404296875 Z",
    className: "fil4 area_cor_fonte_camada_4",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 16584.6,
    y: 12605.54,
    className: "fil4 fnt1 botao camada_4 area_cor_fonte_camada_4 label_camada_4",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "405.89px",
      fontFamily: "'Arial'",
      fontWeight: "Arial",
      textAnchor: "middle"
    }
  }, "N\xEDvel 4"), /*#__PURE__*/React.createElement("path", {
    className: "fil3 camada_4 botao area_fundo_circulo_camada_4",
    d: "M21743.99 12015.68c0,336.11 -272.46,608.57 -608.57,608.57 -336.08,0 -608.55,-272.46 -608.55,-608.57 0,-336.11 272.47,-608.58 608.55,-608.58 336.11,0 608.57,272.47 608.57,608.58z",
    style: {
      fill: "rgb(237, 50, 55)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -130.9418487548828, -32.735464002772915)",
    x: 20750,
    y: 11811
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 21270,
    dy: 310,
    className: "label camada_4 area_cor_fonte_camada_4"
  }, "0")), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 11900,
    y: 11811,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -130.9418560110921, -16.367732001386685)"
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 12420,
    dy: 270,
    className: "label camada_4 area_cor_fonte_camada_4"
  }, "0")), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M13869.23 10971.9l-2019.8 0 0 -1217.15 193.32 0 113.67 0 266.97 0 113.7 0 266.95 0 113.69 0 266.98 0 113.67 0 281.23 0c-42.93,22.78 -65.47,46.33 -65.47,70.47 0,0.11 0,0.25 0,0.35l0 0.03c0.09,7.88 2.58,15.73 7.4,23.48l347.69 1122.82zm-355.09 -1146.68l0 0z",
    style: {
      fill: "url('#gradient-95')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M19564.5 10971.9l2019.79 0 0 -1217.15 -193.31 0 -113.68 0 -266.97 0 -113.69 0 -266.95 0 -113.7 0 -266.97 0 -113.68 0 -281.23 0c42.94,22.78 65.47,46.33 65.47,70.47 0,0.11 0,0.25 0,0.35l0 0.03c-0.08,7.88 -2.57,15.73 -7.4,23.48l-347.68 1122.82zm355.08 -1146.68l0 0z",
    style: {
      fill: "url('#gradient-96')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 camada_3 botao area_fundo_circulo_camada_3",
    d: "M20951.73 10363.32c0,336.11 272.46,608.58 608.57,608.58 336.09,0 608.55,-272.47 608.55,-608.58 0,-336.11 -272.46,-608.57 -608.55,-608.57 -336.11,0 -608.57,272.46 -608.57,608.57z",
    style: {
      fill: "url('#gradient-97')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6 area_cor_interna_1_camada_3",
    d: "M19811.21 9925.79c-189.8,-68.62 -568.84,-128.38 -1071.33,-172.11 341.04,-29.59 596.52,-65.12 787.42,-101 54.42,10.37 104,21.07 148.59,32.07 32.45,8.02 62.25,16.19 89.18,24.52 47.77,14.75 86.66,29.91 116.02,45.48 42.93,22.78 65.49,46.33 65.49,70.47 0,8.02 -2.49,15.98 -7.39,23.88 -16.48,26.48 -60.16,52.17 -127.98,76.69zm-6161.69 0c-67.87,-24.55 -111.53,-50.21 -127.98,-76.71 -4.82,-7.75 -7.31,-15.6 -7.4,-23.48 0,-0.03 0,0 0,-0.03 0,-0.1 0,-0.24 0,-0.35l0 0c0,-57.74 129.11,-112.22 357.63,-160.21 179.48,35.05 423.95,69.16 756.95,97 -456.72,42.85 -801.19,99.39 -979.2,163.78z",
    style: {
      fill: "rgb(247, 171, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7 area_cor_interna_2_camada_3",
    d: "M14954.67 10116.46l0 -0.01 -0.11 0 -18.91 -1.38 -6.92 -0.5c-15.58,-1.15 -31.04,-2.31 -46.42,-3.48l-0.02 0c-22.54,-1.72 -44.86,-3.47 -66.96,-5.26l0 -0.1 -1.23 0 -6.32 -0.51 -3.03 -0.24c-29.01,-2.35 -57.65,-4.77 -85.89,-7.23l0 -0.05 -0.63 0c-29.71,-2.59 -58.98,-5.24 -87.8,-7.94l0 -0.11 -1.11 0 -3.37 -0.32 -1.01 -0.09c-17.09,-1.61 -34.01,-3.24 -50.78,-4.88l0 -0.06 -0.61 0 -3.07 -0.31 -5.66 -0.55 -17.46 -1.74 0 -0.08 -0.82 0 -25.98 -2.64 0 -0.05 -0.42 0 -6.25 -0.64 -4.08 -0.43c-13.49,-1.39 -26.89,-2.82 -40.16,-4.24l0 -0.04 -0.47 0 -12.89 -1.39 -0.22 -0.02 -34.65 -3.82 0 -0.13 -1.16 0 -22.96 -2.6 0 -0.09 -0.73 0c-15.51,-1.77 -30.83,-3.57 -46,-5.37l-3.13 -0.38c-15.84,-1.9 -31.5,-3.82 -46.95,-5.75l-4.51 -0.57c-15.2,-1.9 -30.21,-3.84 -45.03,-5.78l-4.8 -0.63 -1.59 -0.22 0 -0.05 -0.4 0c-13.43,-1.78 -26.68,-3.55 -39.79,-5.36l-0.02 0 -1.38 -0.19 -4.93 -0.69 -12.43 -1.73 0 -0.07 -0.54 0c-10.45,-1.47 -20.78,-2.94 -31,-4.42l-1.47 -0.22 -4.51 -0.66 0 -0.06 -0.43 0c-12.88,-1.89 -25.59,-3.77 -38.15,-5.69l-3.23 -0.48 -11.78 -1.82 0 -0.05 -0.29 0c-9.66,-1.49 -19.19,-3 -28.63,-4.51l-6.03 -0.98c-12.19,-1.96 -24.23,-3.95 -36.06,-5.94l-6.21 -1.06c-11.63,-1.98 -23.08,-3.98 -34.34,-5.98l-0.98 -0.17 0 -0.12 -0.64 0 -4.51 -0.8c-8.21,-1.48 -16.31,-2.96 -24.33,-4.45l0 -0.1 -0.58 0 -8.12 -1.52 -6.22 -1.17c-10.73,-2.04 -21.26,-4.08 -31.62,-6.14l-5.63 -1.11c-10.52,-2.12 -20.83,-4.24 -30.97,-6.38l-5.79 -1.22 -4.86 -1.03 0 -0.19 -0.87 0c-8.62,-1.86 -17.11,-3.73 -25.42,-5.59l-3.33 -0.76c-6.29,-1.43 -12.5,-2.86 -18.61,-4.3l0 -0.07 -0.36 0 -9.21 -2.18 -1.15 -0.28 0 -0.22 -0.92 0 -3.92 -0.95c-8.47,-2.05 -16.76,-4.1 -24.87,-6.17l-6.28 -1.62c-5.96,-1.54 -11.84,-3.09 -17.6,-4.64l0 -0.02 -0.1 0 -5.98 -1.63 -5.06 -1.39 -7.62 -2.13 0 -0.21 -0.72 0 -14.44 -4.17 -3.6 -1.05 0 -0.14 -0.45 0 -0.52 -0.15c-7.52,-2.24 -14.8,-4.48 -21.91,-6.75l-4.57 -1.46c-7.39,-2.39 -14.57,-4.79 -21.49,-7.2l-2.67 -0.94c-2.54,-0.89 -4.9,-1.8 -7.38,-2.69 9.54,-3.45 19.58,-6.88 30.07,-10.28l2.13 0 0 -0.69 6.23 -1.99 1.8 0 0 -0.56 6.8 -2.12 1.25 0 0 -0.38 7.57 -2.31 0.46 0 0 -0.13c11.87,-3.56 24.26,-7.08 37.15,-10.58l0.37 0 0 -0.1 9.64 -2.58 1.08 0 0 -0.29 9.13 -2.39 1.58 0 0 -0.41 8.91 -2.27 1.81 0 0 -0.46 8.92 -2.22 1.8 0 0 -0.45c10.34,-2.54 20.96,-5.07 31.84,-7.59l0.32 0 0 -0.07c7.67,-1.77 15.47,-3.54 23.4,-5.29l0.72 0 0 -0.16 11.56 -2.52 1.84 0 0 -0.4 10.65 -2.28 0.06 0 0 -0.01 12.73 -2.67 0.67 0 0 -0.13 12.41 -2.55 0.98 0 0 -0.2c12.99,-2.63 26.27,-5.24 39.85,-7.83l0.35 0 0 -0.07c9.31,-1.78 18.77,-3.54 28.36,-5.3l1.12 0 0 -0.2c9.44,-1.73 19.02,-3.44 28.73,-5.15l0.74 0 0 -0.13 14.66 -2.55 1.42 0 0 -0.25c20.56,-3.53 41.68,-7.02 63.36,-10.47l0.96 0 0 -0.15 16.07 -2.53 17.39 -2.68 1.37 0 0 -0.22c11.3,-1.72 22.74,-3.44 34.33,-5.14l0.51 0 0 -0.07c12.1,-1.78 24.33,-3.54 36.73,-5.29l0.78 0 0 -0.12 18.4 -2.56 0.36 0 0 -0.06 19.16 -2.62 2.27 0 0 -0.3 17.7 -2.38 1.06 0 0 -0.14 19.31 -2.54 2.13 0 0 -0.27 18.67 -2.41 0.08 0 0 -0.01 21.15 -2.67 0.3 0 0 -0.04 21.31 -2.64 0.12 0 0 -0.01c14.66,-1.8 29.49,-3.59 44.48,-5.35l1.07 0 0 -0.12 22.01 -2.56 2.11 0 0 -0.24 21.38 -2.43 0.06 0 0 -0.01 23.96 -2.67 0.15 0 0 -0.02c16.31,-1.8 32.8,-3.59 49.47,-5.35l1.45 0 0 -0.15c16.61,-1.75 33.4,-3.49 50.35,-5.2l0.56 0 0 -0.06 26.24 -2.62 0.56 0 0 -0.06c20.62,-2.04 41.49,-4.04 62.6,-6.03 117.01,9.79 245.24,18.82 385.14,26.82 -316.73,44.51 -507.9,102.26 -507.9,165.39 0,62.84 189.45,120.35 503.62,164.77l-3.84 1.06 -7.31 -0.49 -3.92 -0.28 -39.84 -2.82zm3500.29 3.59c-24.63,-6.8 -52.59,-13.44 -83.66,-19.86 241.17,-41.35 382.7,-91.68 382.7,-145.97 0,-63.29 -192.23,-121.19 -510.44,-165.76 182.94,-10.16 347.71,-21.89 496.32,-34.78l41.33 3.66 0 0.04 0.41 0 26.38 2.39 0 0.29 3.1 0 26.38 2.46 0 0.21 2.21 0 27.26 2.61 0 0.07 0.79 0 26.01 2.54 0 0.15 1.44 0c17.56,1.74 34.95,3.49 52.15,5.27l0 0.08 0.78 0 23.34 2.44 0 0.24 2.3 0 24.5 2.62 0 0.06 0.57 0 23.54 2.57 0 0.12 1.01 0 23.11 2.57 0 0.11 0.96 0 23.16 2.64 0 0.03 0.27 0c15.26,1.75 30.35,3.53 45.28,5.33l0 0.03 0.3 0 21.14 2.56 0 0.12 0.99 0 20.45 2.53 0 0.15 1.15 0 20.28 2.57 0 0.11 0.91 0 20.53 2.65 0 0.03 0.25 0c13.47,1.76 26.78,3.53 39.95,5.31l0 0.05 0.38 0c12.52,1.7 24.9,3.41 37.13,5.14l0 0.22 1.58 0 17.18 2.44 0 0.24 1.64 0 17.12 2.49 0 0.19 1.3 0 17.45 2.59 0 0.08 0.57 0 15.51 2.35 0 0.34 2.19 0 16.57 2.56 0 0.12 0.79 0c27.4,4.27 53.94,8.61 79.6,13.02l0 0.38 2.18 0 13.89 2.41 0 0.27 1.52 0 14.56 2.58 0 0.09 0.51 0c9.79,1.76 19.45,3.53 28.97,5.3l0 0.06 0.32 0c13.58,2.54 26.88,5.09 39.87,7.68l0 0.36 1.84 0 11.56 2.32 0 0.36 1.8 0 11.6 2.37 0 0.31 1.51 0 11.89 2.49 0 0.19 0.91 0c12.52,2.66 24.7,5.33 36.61,8.02l0 0.02 0.1 0c26.52,5.99 51.5,12.08 74.92,18.25l0 0.51 1.93 0 8.8 2.36 0 0.32 1.19 0 9.52 2.62 0 0.06 0.23 0c6.31,1.75 12.47,3.51 18.53,5.28l0 0.08 0.29 0 7.75 2.28 0 0.39 1.29 0 6.75 2.05 0 0.64 2.1 0c5.68,1.74 11.21,3.51 16.65,5.26l0 0.1 0.3 0 7.75 2.55 0 0.12 0.37 0 7.66 2.59 0 0.09 0.28 0c4.78,1.64 9.48,3.28 14.03,4.93 -2.58,0.93 -5.02,1.86 -7.66,2.78l-0.93 0.34 -0.36 0 0 0.13 -0.97 0.34 -6.41 2.2 -0.66 0 0 0.23 -7.34 2.45 -0.69 0 0 0.24 -6.86 2.23 -0.67 0.21 -0.52 0 0 0.17 -2.72 0.87 -5.22 1.65 -0.09 0 0 0.03c-5.57,1.74 -11.27,3.48 -17.09,5.22l-4.12 1.21 -5.39 1.57 -0.2 0 0 0.06c-5.84,1.7 -11.78,3.38 -17.85,5.06l-0.89 0.24 -0.02 0 0 0.01 -3.33 0.91c-7.91,2.17 -16.01,4.33 -24.31,6.47l-6.03 1.55c-8.26,2.1 -16.69,4.21 -25.32,6.29l-5.24 1.26c-6.94,1.65 -13.99,3.31 -21.16,4.95l-0.36 0 0 0.08 -7.43 1.7 -2.75 0.63 -13.25 2.94 -0.68 0 0 0.15 -18.29 3.95 -4.01 0.84 -14.88 3.11 -0.34 0 0 0.07 -12.78 2.6 -0.62 0 0 0.12 -3.46 0.7 -5.09 1.01 -4.28 0.85 -0.57 0 0 0.11 -13.15 2.58 -0.25 0 0 0.04 -13.71 2.64 -6.18 1.16 -22.68 4.19 -0.3 0 0 0.06 -10.51 1.89 -5.31 0.95c-9.68,1.73 -19.51,3.44 -29.46,5.15l-0.27 0 0 0.04 -5.32 0.91 -5.66 0.97 -4.48 0.75 -0.62 0 0 0.11 -15.5 2.57 -0.58 0 0 0.1 -15.14 2.46 -0.75 0.12 -0.18 0 0 0.03 -5.05 0.82c-13.36,2.14 -26.93,4.26 -40.72,6.37l-3.17 0.48 -20.01 3.02 -0.72 0 0 0.11 -22.65 3.33 -0.79 0.11c-14.66,2.13 -29.53,4.24 -44.61,6.32l-4.55 0.63 -1.62 0.22 -0.81 0 0 0.11c-13.49,1.86 -27.14,3.69 -40.95,5.52l-4.79 0.63c-11.39,1.49 -22.88,2.98 -34.49,4.46l-0.17 0 0 0.02 -10.37 1.3 -4.52 0.57 -6.33 0.79 -0.21 0 0 0.02c-13.33,1.66 -26.79,3.31 -40.4,4.94l-3.14 0.38 -22.84 2.69 -0.61 0 0 0.07c-26.76,3.13 -54.04,6.21 -81.83,9.22l-0.78 0.09c-12.47,1.35 -25.04,2.69 -37.71,4.02l-0.27 0 0 0.03 -15.19 1.58 -4.08 0.43 -6.29 0.64 -1.23 0 0 0.13c-14.28,1.47 -28.69,2.92 -43.21,4.36l-5.97 0.59 -30.5 2.96 -0.71 0 0 0.07 -22.7 2.16 -1.71 0.16c-19.18,1.8 -38.55,3.59 -58.14,5.34l-0.29 0.03c-31.71,2.84 -63.91,5.61 -96.63,8.32l-0.07 0 0 0.01 -22.88 1.87 -4.27 0.35 -39.33 3.13 -0.51 0 0 0.04 -19.85 1.55 -0.72 0.06 -13.39 1.03 -0.88 0 0 0.07 -34.73 2.61 -0.1 0 0 0.01 -10.15 0.74 -8.1 0.6 -18.35 1.33 -0.92 0 0 0.07 -36.88 2.61 -0.63 0 0 0.05 -0.78 0.05 -5.13 0.36 -6.82 0.46z",
    style: {
      fill: "url('#gradient-100')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7 area_cor_interna_2_camada_3",
    d: "M16654.67 10170.46l0 -0.06 -11.4 0c-62.55,-0.31 -124.51,-0.85 -185.9,-1.59l0 -0.04 -2.99 0c-66.05,-0.82 -131.4,-1.88 -195.94,-3.2l0 -0.07 -3.5 0c-23.95,-0.49 -47.78,-1.02 -71.5,-1.58l0 -0.04 -1.98 0c-21.18,-0.5 -42.25,-1.03 -63.24,-1.59l0 -0.04 -1.78 0c-19.6,-0.52 -39.12,-1.06 -58.55,-1.63l0 -0.01 -0.25 0c-17.38,-0.5 -34.69,-1.02 -51.93,-1.56l0 -0.07 -2.15 0c-32.13,-1 -64.04,-2.07 -95.69,-3.2l0 -0.06 -1.36 0c-14.26,-0.51 -28.5,-1.02 -42.66,-1.56l0 -0.07 -1.73 0c-27.35,-1.03 -54.48,-2.12 -81.43,-3.25l0 -0.01 -0.17 0 -37.33 -1.6 0 -0.03 -0.68 0c-23.85,-1.04 -47.55,-2.11 -71.06,-3.23l0 -0.03 -0.68 0 -33.57 -1.63 0 0 -0.11 0c-10.86,-0.53 -21.72,-1.06 -32.5,-1.61l0 -0.02 -0.24 0c-20.73,-1.05 -41.28,-2.14 -61.72,-3.25l0 -0.01 -0.23 0 -29.12 -1.59 0 -0.04 -0.78 0c-37.21,-2.08 -73.89,-4.26 -110.1,-6.52l0 -0.01 -0.05 0c-33.6,-2.09 -66.72,-4.26 -99.41,-6.5l0 -0.02 -0.18 0 -22.65 -1.56 0 -0.07 -0.98 0c-29.98,-2.1 -59.54,-4.27 -88.7,-6.5l0 -0.02 -0.31 0 -20.88 -1.61 0 -0.02 -0.25 0c-33.66,-2.62 -66.72,-5.33 -99.22,-8.1l0 -0.05 -0.57 0 -19 -1.63 0 0 -0.03 0c-24.27,-2.12 -48.13,-4.29 -71.71,-6.49l0 -0.03 -0.42 0c-11.36,-1.06 -22.62,-2.13 -33.82,-3.22l0 -0.05 -0.51 0c-21.87,-2.11 -43.47,-4.25 -64.71,-6.44l0 -0.08 -0.79 0 -15.52 -1.62 0 -0.01 -0.11 0c-20.36,-2.13 -40.47,-4.28 -60.22,-6.48l0 -0.04 -0.36 0 -14.31 -1.62 0 -0.01 -0.11 0c-14.27,-1.61 -28.36,-3.24 -42.29,-4.89l0 0 -0.03 0c-48.85,-5.77 -95.61,-11.76 -140.19,-17.93l0 -0.01 -0.12 0 -11.3 -1.56 0 -0.07 -0.46 0c-22.72,-3.19 -44.86,-6.43 -66.39,-9.72l0 -0.06 -0.39 0c-7.03,-1.08 -13.91,-2.17 -20.81,-3.25l0 -0.02 -0.08 0c-40.27,-6.33 -78.3,-12.85 -114.06,-19.52l0 -0.04 -0.19 0c-25.59,-4.78 -50,-9.65 -73.18,-14.59l0 -0.09 -0.39 0c-15.05,-3.21 -29.63,-6.46 -43.64,-9.74l0 -0.04 -0.17 0 -6.35 -1.53 0 -0.1 -0.43 0c-15.79,-3.76 -30.84,-7.56 -45.23,-11.41l0 0 -0.03 0c-17.94,-4.8 -34.83,-9.65 -50.51,-14.56l0 -0.12 -0.37 0c-1.55,-0.48 -3,-0.98 -4.52,-1.46l0 -0.17 -0.51 0c-10.09,-3.23 -19.74,-6.48 -28.84,-9.75l0 -0.03 -0.09 0c-4.48,-1.61 -8.74,-3.23 -12.96,-4.86l0 -0.04 -0.09 0 -2.76 -1.03c1.9,-0.75 3.97,-1.49 5.92,-2.22l0.19 0 0 -0.07c10.08,-3.82 20.83,-7.6 32.25,-11.35l0.37 0 0 -0.12 4.64 -1.51 0.25 0 0 -0.08c1.61,-0.51 3.15,-1.04 4.78,-1.55l0.11 0 0 -0.03c12.13,-3.83 24.95,-7.63 38.46,-11.39l0.67 0 0 -0.19c3.7,-1.02 7.55,-2.04 11.35,-3.06l0.06 0 0 -0.02c16.36,-4.39 33.6,-8.74 51.79,-13.03l0.39 0 0 -0.09c11.51,-2.71 23.44,-5.4 35.67,-8.06l0.2 0 0 -0.05c7.46,-1.62 15.04,-3.24 22.77,-4.85l0.06 0 0 -0.01 7.84 -1.61 0.31 0 0 -0.07c10.59,-2.17 21.38,-4.32 32.43,-6.46l0.19 0 0 -0.04c8.43,-1.62 17.02,-3.24 25.72,-4.85l0.36 0 0 -0.07c11.73,-2.17 23.61,-4.32 35.82,-6.45l0.06 0 0 -0.01 9.48 -1.62 0.3 0 0 -0.05 9.25 -1.58 0.54 0 0 -0.1c22.61,-3.83 45.92,-7.61 70.07,-11.32l0.04 0 0 0 10.78 -1.63 0.63 0 0 -0.09c6.99,-1.06 13.96,-2.12 21.07,-3.17l0.13 0 0 -0.01c11.13,-1.64 22.4,-3.27 33.82,-4.88l0.42 0 0 -0.06 11.36 -1.57 0.05 0 0 -0.01c27.9,-3.88 56.63,-7.68 86.23,-11.4l0.19 0 0 -0.03 12.88 -1.61 0.17 0 0 -0.01c22.23,-2.76 44.87,-5.47 68,-8.14l0.48 0 0 -0.05 13.9 -1.58 0.78 0 0 -0.08c19.17,-2.18 38.57,-4.33 58.33,-6.44l0.37 0 0 -0.04c10.18,-1.09 20.5,-2.15 30.83,-3.22l0.14 0 0 -0.01 15.71 -1.62 0.6 0 0 -0.06c16.04,-1.63 32.3,-3.24 48.7,-4.83l0.22 0 0 -0.02c11.23,-1.09 22.52,-2.17 33.92,-3.25l0.32 0 0 -0.02 17.25 -1.6 0.68 0 0 -0.07c17.71,-1.63 35.57,-3.24 53.66,-4.83l0.15 0 0 -0.01 18.75 -1.62 0.82 0 0 -0.07c25.57,-2.2 51.48,-4.35 77.78,-6.45l0.49 0 0 -0.04c42.31,-3.38 85.51,-6.63 129.62,-9.74l0.82 0 0 -0.06 22.77 -1.57 0.06 0 0 -0.01 23.61 -1.62 0.84 0 0 -0.06c16.11,-1.09 32.34,-2.15 48.66,-3.2l0.26 0 0 -0.02 25.56 -1.61 0.53 0 0 -0.04 25.68 -1.6 0.41 0 0 -0.02c27.31,-1.67 54.89,-3.29 82.77,-4.87l0.39 0 0 -0.02 29.18 -1.61 0.17 0 0 -0.01c20.3,-1.11 40.74,-2.19 61.33,-3.25l0.63 0 0 -0.03 31.64 -1.6 0.97 0 0 -0.04 32.21 -1.59 0.4 0 0 -0.02c23.42,-1.12 47.06,-2.19 70.82,-3.24l0.92 0 0 -0.04 36.55 -1.59 0.96 0 0 -0.05c12.74,-0.54 25.52,-1.06 38.34,-1.58l0.79 0 0 -0.03c27.92,-1.13 56.1,-2.2 84.43,-3.23l1.99 0 0 -0.08c30.81,-1.12 61.85,-2.18 93.14,-3.18l1.43 0 0 -0.05c17.1,-0.54 34.27,-1.07 51.51,-1.58l0.67 0 0 -0.02c18.85,-0.56 37.79,-1.1 56.81,-1.62l0.26 0 0 0c20.93,-0.57 41.97,-1.11 63.09,-1.63l2.13 0 0 -0.05c22.9,-0.56 45.91,-1.08 69.03,-1.58l1.09 0 0 -0.02c27.06,-0.58 54.27,-1.12 81.62,-1.61l1.53 0 0 -0.02c33.37,-0.6 66.92,-1.15 100.68,-1.61l6.94 0 0 -0.09c48.74,-0.66 97.91,-1.16 147.41,-1.54l9.12 0 0 -0.07c61.25,-0.44 123.04,-0.68 185.33,-0.68 62.67,0 124.82,0.24 186.44,0.69l0 0.06 8.01 0c49.88,0.38 99.41,0.89 148.52,1.56l0 0.07 5.82 0c33.6,0.46 66.96,1 100.17,1.6l0 0.03 2.05 0c27.17,0.49 54.21,1.02 81.11,1.59l0 0.04 1.6 0c22.94,0.49 45.77,1.01 68.51,1.57l0 0.06 2.64 0c20.95,0.52 41.81,1.05 62.58,1.62l0 0.01 0.78 0c18.83,0.52 37.6,1.05 56.29,1.6l0 0.04 1.19 0c17.06,0.5 34.05,1.03 50.99,1.57l0 0.06 1.94 0c31.67,1.01 63.08,2.09 94.26,3.22l0 0.04 0.87 0c14.44,0.52 28.82,1.06 43.15,1.61l0 0.02 0.49 0c26.65,1.02 53.14,2.09 79.41,3.2l0 0.06 1.48 0 36.02 1.56 0 0.07 1.45 0c23.58,1.04 47.05,2.11 70.3,3.22l0 0.04 0.91 0 31.7 1.56 0 0.07 1.48 0c31.35,1.56 62.38,3.18 93.09,4.86l0 0.03 0.68 0 28.67 1.58 0 0.05 0.9 0c27.7,1.57 55.11,3.18 82.26,4.84l0 0.05 0.92 0 25.17 1.57 0 0.07 1.04 0 25.05 1.58 0 0.05 0.77 0c24.46,1.57 48.63,3.2 72.6,4.85l0 0.04 0.57 0c37.93,2.62 75.29,5.33 111.94,8.14l0 0.01 0.18 0c27.51,2.11 54.6,4.28 81.35,6.5l0 0.02 0.3 0 19.27 1.62 0 0.01 0.23 0c12.5,1.06 24.94,2.12 37.26,3.2l0 0.06 0.67 0c24.04,2.11 47.72,4.25 71.08,6.45l0 0.07 0.83 0 17.11 1.62 0 0.02 0.12 0c27.63,2.63 54.77,5.33 81.4,8.08l0 0.07 0.65 0c40.68,4.21 80.15,8.55 118.38,13.01l0 0.03 0.25 0c9.22,1.08 18.4,2.16 27.47,3.25l0 0.02 0.16 0 12.89 1.57 0 0.06 0.44 0 12.6 1.54 0 0.08 0.68 0 12.37 1.55 0 0.09 0.7 0 12.34 1.57 0 0.06 0.45 0 12.59 1.6 0 0.03 0.21 0c16.53,2.14 32.73,4.31 48.71,6.5l0 0.02 0.18 0 11.24 1.55 0 0.08 0.56 0c19.25,2.68 38.08,5.4 56.5,8.14l0 0.01 0.06 0c7.08,1.06 14.18,2.11 21.14,3.18l0 0.08 0.54 0c6.98,1.08 13.81,2.16 20.66,3.24l0 0.03 0.16 0c33.56,5.29 65.62,10.72 96.04,16.26l0 0.04 0.23 0c8.76,1.6 17.36,3.2 25.86,4.82l0 0.07 0.4 0c19.61,3.74 38.52,7.52 56.67,11.36l0 0.06 0.29 0c7.64,1.61 15.16,3.24 22.54,4.87l0 0.02 0.09 0c16.99,3.75 33.26,7.56 48.82,11.41l0 0 0.02 0c13.03,3.22 25.48,6.48 37.49,9.75l0 0.04 0.12 0c3.83,1.05 7.57,2.1 11.29,3.15l0 0.11 0.38 0c9.45,2.67 18.57,5.36 27.34,8.07l0 0.08 0.25 0 4.64 1.43 0 0.2 0.62 0c11.89,3.75 23.09,7.53 33.62,11.35l0 0.06 0.16 0c4.43,1.61 8.7,3.22 12.89,4.84l0 0.06 0.15 0 1.58 0.59 -2.76 1.03 -0.6 0 0 0.23c-2.65,1.02 -5.36,2.03 -8.1,3.04l-0.06 0 0 0.02c-20.99,7.74 -44.8,15.35 -71.29,22.81l-0.45 0 0 0.12c-3.72,1.05 -7.49,2.09 -11.31,3.13l-0.11 0 0 0.03c-20.25,5.51 -41.95,10.94 -65.09,16.28l-0.13 0 0 0.03c-9.44,2.18 -19.15,4.34 -29.07,6.49l-0.28 0 0 0.06c-7.47,1.62 -15.06,3.23 -22.78,4.84l-0.05 0 0 0.01c-10.55,2.18 -21.36,4.35 -32.4,6.51l-0.2 0 0 0.04 -8.1 1.59 -0.06 0 0 0c-8.51,1.64 -17.18,3.27 -25.96,4.89l-0.13 0 0 0.02c-17.88,3.3 -36.36,6.55 -55.36,9.76l-0.07 0 0 0.01 -9.58 1.62 -0.21 0 0 0.04 -9.76 1.59 -0.02 0 0 0.01c-23.54,3.86 -47.86,7.67 -72.98,11.41l-0.39 0 0 0.06c-18.4,2.73 -37.24,5.43 -56.46,8.09l-0.62 0 0 0.09 -11.18 1.54 -0.23 0 0 0.03c-20.13,2.75 -40.73,5.46 -61.73,8.12l-0.23 0 0 0.04 -12.57 1.59 -0.48 0 0 0.07 -12.73 1.57 -0.31 0 0 0.03 -12.99 1.59 -0.05 0 0 0.01c-18.08,2.2 -36.41,4.38 -55.07,6.52l-0.37 0 0 0.04 -14.06 1.59 -0.62 0 0 0.07c-24.32,2.74 -49.12,5.44 -74.38,8.08l-0.62 0 0 0.06c-15.58,1.63 -31.33,3.24 -47.26,4.83l-0.03 0 0 0c-16.54,1.65 -33.22,3.29 -50.13,4.89l-0.41 0 0 0.05c-29.19,2.77 -58.89,5.47 -89.15,8.11l-0.54 0 0 0.04c-31.93,2.79 -64.5,5.48 -97.58,8.11l-0.25 0 0 0.02 -20.44 1.61 -0.76 0 0 0.06 -20.37 1.57 -0.82 0 0 0.06 -20.81 1.57 -0.39 0 0 0.03c-29.79,2.23 -59.99,4.39 -90.62,6.49l-0.69 0 0 0.05c-24.1,1.65 -48.45,3.27 -73.05,4.84l-0.32 0 0 0.02 -25.53 1.61 -0.57 0 0 0.04 -25.99 1.6 -0.09 0 0 0c-18.21,1.11 -36.55,2.19 -55.01,3.25l-0.43 0 0 0.03 -28.07 1.61 -1.28 0 0 0.07 -28.61 1.56 -0.74 0 0 0.04c-20.28,1.1 -40.66,2.18 -61.21,3.22l-0.75 0 0 0.04 -31.99 1.59 -0.62 0 0 0.03 -33.06 1.6 -1.18 0 0 0.06c-23.35,1.1 -46.88,2.17 -70.55,3.2l-1.2 0 0 0.05 -36.81 1.58 -0.69 0 0 0.03c-26.79,1.12 -53.74,2.2 -80.92,3.23l-0.61 0 0 0.03c-14.53,0.55 -29.14,1.08 -43.78,1.6l-1.88 0 0 0.07c-31.47,1.13 -63.21,2.19 -95.17,3.19l-1.03 0 0 0.04c-17.61,0.55 -35.29,1.08 -53.05,1.59l-0.76 0 0 0.03c-19.26,0.56 -38.61,1.09 -58.04,1.61l-0.66 0 0 0.01c-21.36,0.57 -42.8,1.1 -64.35,1.62l-0.87 0 0 0.02c-24.09,0.57 -48.29,1.11 -72.62,1.6l-2.38 0 0 0.05c-64.89,1.33 -130.63,2.4 -197.05,3.22l-3.51 0 0 0.04c-61.21,0.75 -123.02,1.28 -185.38,1.59l-10.28 0 0 0.05c-38.04,0.18 -76.28,0.26 -114.7,0.26 -38.05,0 -75.91,-0.09 -113.58,-0.25z",
    style: {
      fill: "url('#gradient-100')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14102.240234375 10448.2099609375 L 14186.6796875 10899.009765625 L 14453.8701171875 10631.830078125 Z",
    className: "fil9",
    style: {
      fill: "url('#gradient-101')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19358.4609375 10485.4296875 L 19311.48046875 10899.009765625 L 19044.259765625 10631.830078125 Z",
    className: "fil0",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14260.75 10485.4296875 L 14307.73046875 10899.009765625 L 14574.9501953125 10631.830078125 Z",
    className: "fil0",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10 botao camada_3 area_cor_camada_3",
    d: "M16616.76 11496.94c-552.09,0 -991.86,-12.6 -1342.38,-32.66 -117.44,-6.72 -225.08,-14.31 -323.31,-22.52 -279.55,-23.37 -484.77,-52.01 -635.44,-81.43 -25.4,-4.97 -49.15,-9.92 -71.53,-14.91 -27.83,-6.19 -53.39,-12.38 -76.89,-18.54 -74.91,-19.64 -128.85,-38.87 -167.71,-56.42 -27.24,-12.3 -47.08,-23.78 -61.5,-33.94 -38.66,-27.31 -38.5,-45.35 -38.5,-45.35l-33.16 -107.1 -4.26 -13.75 -316.39 -1021.74 -4.13 -13.34 -53.01 -171.12 -3.55 -11.49c13.86,22.31 46.88,44.04 97.31,65.04l0 0c363.12,151.05 1628.18,262.53 3133.03,262.53 1504.84,0 2769.91,-111.48 3133.02,-262.53l0 0c50.44,-21 83.44,-42.73 97.3,-65.04l-57.21 184.77 -3.46 11.18 -316.42 1021.74 -9.6 31.09 -27.81 89.76c0,0 -19.81,31.26 -135.75,73.78 -35.88,13.18 -81.03,27.45 -137.6,42.18 -53.81,14.01 -117.97,28.46 -194.52,42.85 -160.25,30.12 -374.72,59.95 -661.01,84.79 -124.76,10.82 -263.08,20.67 -416.65,29.19 -364.4,20.25 -814.11,32.98 -1368.87,32.98zm3336.34 -1667.95l0 0 0 0zm-6475.52 0l0 0 0 0z",
    style: {
      fill: "url('#gradient-102')"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -11.118633270262762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14070.7197265625 10492.41015625 L 14154.400390625 10939.1796875 L 14419.2099609375 10674.3701171875 Z",
    className: "fil0 area_cor_fonte_camada_3",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19407.8203125 10492.41015625 L 19324.140625 10939.1796875 L 19059.330078125 10674.3701171875 Z",
    className: "fil0 area_cor_fonte_camada_3",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 16584.6,
    y: 10952.68,
    className: "fil0 fnt2 botao camada_3 area_cor_fonte_camada_3 label_camada_3",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "405.48px",
      fontFamily: "'Arial'",
      fontWeight: "Arial",
      textAnchor: "middle"
    }
  }, "N\xEDvel 3"), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "405.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 21175,
    y: 10161,
    transform: "matrix(1, 0, 0, 1, -127.98814868352747, -47.99555969238236)"
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 21675,
    dy: 320,
    className: "label camada_3 area_cor_fonte_camada_3"
  }, "0")), /*#__PURE__*/React.createElement("path", {
    className: "fil4 camada_3 botao area_fundo_circulo_camada_3",
    d: "M12481.99 10363.32c0,336.11 -272.46,608.58 -608.57,608.58 -336.08,0 -608.55,-272.47 -608.55,-608.58 0,-336.11 272.47,-608.57 608.55,-608.57 336.11,0 608.57,272.46 608.57,608.57z",
    style: {
      fill: "url('#gradient-99')"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "tituto-grafico multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 11450,
    y: 10161,
    transform: "matrix(1, 0, 0, 1, -95.9911197039819, -47.99555985199095)"
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 11950,
    dy: 300,
    className: "label camada_3 area_cor_fonte_camada_3"
  }, "0")), /*#__PURE__*/React.createElement("g", {
    id: "g-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil5 area_cor_interna_3_camada_3",
    d: "M16235.3 10006.29l-8.75 1.86c-47.58,8 -114.6,7.32 -130.14,46.11 0,41.71 176.76,51.51 207.84,56.09l686.65 58.94c46.61,6.2 45.64,-5.39 50.5,9.11l85.47 -0.99 2.91 -0.06c25.25,-0.37 50.5,-0.75 76.73,-1.18l3.88 -0.06c26.22,-0.44 51.47,-0.87 77.7,-1.36l0.97 -0.07c26.22,-0.49 52.44,-1.05 78.67,-1.61l0.97 0c157.33,-3.53 310.78,-8.3 459.38,-14.19l0.97 0c24.28,-0.99 48.56,-1.98 71.87,-3.04l2.91 -0.12c48.56,-2.05 96.15,-4.22 142.77,-6.51l1.94 -0.12c23.31,-1.12 46.62,-2.3 69.93,-3.54l0.97 -0.06c23.31,-1.17 46.62,-2.41 68.96,-3.72l1.94 -0.12c20.4,-1.12 40.79,-2.23 60.22,-3.41 44.67,-11.65 81.58,-23.86 107.8,-36.5 -331.18,-61.11 -943.04,-102.08 -1643.29,-102.08 -166.07,0 -326.32,2.3 -479.77,6.63z",
    style: {
      fill: "rgb(255, 234, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5 area_cor_interna_3_camada_3",
    d: "M16083.79 10173.51l-175.79 -36.32c-68.96,-4.28 -202.98,-18.66 -256.4,-52.93 -31.08,-20.14 -3.89,-0.74 -30.11,-25.16l9.71 -22.69c-291.36,21.88 -523.48,52.37 -665.28,88.07l0.98 0.06 7.77 0.56c18.45,1.3 37.87,2.61 56.33,3.84l10.68 0.69c19.42,1.3 39.82,2.54 59.24,3.84l3.89 0.25c20.39,1.24 40.79,2.48 60.21,3.65l12.63 0.75c20.39,1.17 40.79,2.29 60.21,3.47l6.8 0.37c44.68,2.42 89.35,4.77 135,7l5.83 0.31c22.34,1.12 45.64,2.17 68.95,3.29l0.97 0.06c23.31,1.05 46.62,2.04 69.93,3.04l5.83 0.31c22.34,0.93 45.65,1.86 67.98,2.79l7.77 0.31c47.59,1.85 96.15,3.65 144.71,5.26l1.95 0.07c24.28,0.86 49.53,1.67 75.75,2.47l0 0c24.28,0.75 49.53,1.49 75.75,2.24l2.92 0.06c50.5,1.42 101,2.66 151.51,3.84l4.85 0.06 19.43 0.44z",
    style: {
      fill: "rgb(255, 234, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5 area_cor_interna_3_camada_3",
    d: "M17041.4 10178.4c-4.86,-14.5 -3.89,-2.91 -50.5,-9.11l-686.65 -58.94c-31.08,-4.58 -207.84,-14.38 -207.84,-56.09 15.54,-38.79 82.56,-38.11 130.14,-46.11l8.75 -1.86c-102.95,2.92 -202.02,6.7 -296.22,11.28 -16.51,8.12 -31.08,19.15 -42.74,36.69 47.59,68.55 172.88,70.97 278.74,90.86 43.71,8.31 105.86,18.28 156.37,25.41l48.56 7.81 3.88 0.06 0 0c26.22,0.25 53.42,0.5 79.64,0.75l4.86 0.06c26.22,0.18 52.44,0.37 78.66,0.49l2.92 0.07c27.19,0.12 53.41,0.24 80.61,0.31l2.91 0c27.2,0.06 54.39,0.12 81.58,0.12l0 0c27.2,0 54.39,-0.06 81.58,-0.12l5.83 0c26.22,-0.07 52.45,-0.19 78.67,-0.31l0.97 -0.07c27.2,-0.12 54.39,-0.31 81.58,-0.55l0.97 0 76.73 -0.75z",
    style: {
      fill: "rgb(255, 234, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5 area_cor_interna_3_camada_3",
    d: "M16380.01 10178.34l-48.56 -7.81c-50.51,-7.13 -112.66,-17.1 -156.37,-25.41 -105.86,-19.89 -231.15,-22.31 -278.74,-90.86 11.66,-17.54 26.23,-28.57 42.74,-36.69 -108.78,5.27 -211.73,11.59 -307.88,18.84l-9.71 22.69c26.22,24.42 -0.97,5.02 30.11,25.16 53.42,34.27 187.44,48.65 256.4,52.93l175.79 36.32 54.38 1.11 7.77 0.13c24.28,0.49 48.56,0.92 73.82,1.36l6.79 0.12c25.26,0.37 50.51,0.81 75.76,1.12l0.97 0.06 76.73 0.93z",
    style: {
      fill: "rgb(255, 234, 0)"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.920998 0 0 1 5540.85 2775.18)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 23047.73828125 9821.5546875",
    style: {
      fill: "rgb(43, 41, 41)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08791037648916245, 0, 0, 0.08791037648916245, -903.756799697876, -432.5189514160156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-5",
    transform: "matrix(1, 0, 0, 1, -81.83865211059833, 16.367731601210835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20102.23046875 9319.5498046875 L 20194.48046875 9319.5498046875 L 20461.4296875 9319.5498046875 L 20575.130859375 9319.5498046875 L 20842.109375 9319.5498046875 L 20955.76953125 9319.5498046875 L 21222.75 9319.5498046875 L 21336.44921875 9319.5498046875 L 21603.390625 9319.5498046875 L 21717.08984375 9319.5498046875 L 21827.08984375 9319.5498046875 L 21827.08984375 8102.419921875 L 21641.900390625 8102.419921875 L 21528.23046875 8102.419921875 L 21261.25 8102.419921875 L 21147.560546875 8102.419921875 L 20880.609375 8102.419921875 L 20766.919921875 8102.419921875 L 20499.939453125 8102.419921875 L 20479.119140625 8102.419921875 Z",
    className: "fil0",
    style: {
      fill: "url('#gradient-103')"
    },
    transform: "matrix(0.929157257080078, 0, 0, 0.929157257080078, 1308.1671153254938, 638.6416625976558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 camada_2 botao area_fundo_circulo_camada_2",
    d: "M21218.51 8711c0,336.08 272.47,608.55 608.58,608.55 336.08,0 608.55,-272.47 608.55,-608.55 0,-336.1 -272.47,-608.58 -608.55,-608.58 -336.11,0 -608.58,272.48 -608.58,608.58z",
    style: {
      fill: "url('#gradient-105')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13331.5 9319.5498046875 L 13239.240234375 9319.5498046875 L 12972.2900390625 9319.5498046875 L 12858.599609375 9319.5498046875 L 12591.6201171875 9319.5498046875 L 12477.9501953125 9319.5498046875 L 12210.9697265625 9319.5498046875 L 12097.2802734375 9319.5498046875 L 11830.330078125 9319.5498046875 L 11716.6396484375 9319.5498046875 L 11606.6298828125 9319.5498046875 L 11606.6298828125 8102.419921875 L 11791.830078125 8102.419921875 L 11905.5 8102.419921875 L 12172.4697265625 8102.419921875 L 12286.169921875 8102.419921875 L 12553.1103515625 8102.419921875 L 12666.8095703125 8102.419921875 L 12933.7900390625 8102.419921875 L 12954.6103515625 8102.419921875 Z",
    className: "fil2",
    style: {
      fill: "url('#gradient-104')"
    },
    transform: "matrix(1, 0, 0, 1, 143.54125763026286, -4.547473508864641e-13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 camada_2 botao area_fundo_circulo_camada_2",
    d: "M12215.21 8711c0,336.08 -272.47,608.55 -608.58,608.55 -336.08,0 -608.55,-272.47 -608.55,-608.55 0,-336.1 272.47,-608.58 608.55,-608.58 336.11,0 608.58,272.48 608.58,608.58z",
    style: {
      fill: "url('#gradient-106')"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_2_camada_2",
    d: "M15244.07 8104.32l-1.22 -29.66 261.97 -61.65c252.22,-31.1 88.95,-16.99 349.69,-22.61 -37.77,-22.06 -45.08,-1.99 -82.85,-17.76 383.81,0.67 801.74,-58.89 1203.83,-26.02 181.55,14.77 393.56,18.97 577.54,38.82 155.97,16.87 242.48,31.43 391.13,72.45 35.33,9.6 53.61,11.47 63.36,28.9 276.58,20.51 509.31,47.53 679.89,78.96 43.86,-20.29 67.02,-41.46 67.02,-63.3 0,-140.84 -951.61,-254.87 -2124.98,-254.87 -1172.15,0 -2123.76,114.03 -2123.76,254.87 0,31.76 48.74,62.09 137.68,90.21l2.44 0.22c136.47,-34.3 342.39,-64.51 598.26,-88.56z",
    style: {
      fill: "rgb(247, 217, 64)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_2_camada_2",
    d: "M18007.52 8086.79c-9.75,-17.43 -28.03,-19.3 -63.36,-28.9 -148.65,-41.02 -235.16,-55.58 -391.13,-72.45 -183.98,-19.85 -395.99,-24.05 -577.54,-38.82 -402.09,-32.87 -820.02,26.69 -1203.83,26.02 37.77,15.77 45.08,-4.3 82.85,17.76 -260.74,5.62 -97.47,-8.49 -349.69,22.61l-261.97 61.65 1.22 29.66c398.43,-37.49 917.49,-60.21 1486.51,-60.21 472.76,0 913.84,15.77 1276.94,42.68z",
    style: {
      fill: "rgb(247, 217, 64)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_2_camada_2",
    d: "M17241.11 8050.39c-316.8,-55.36 -993.04,-35.95 -1245.26,6.95 230.29,-8.49 477.64,-13.23 734.73,-13.23 175.46,0 346.04,2.2 510.53,6.28z",
    style: {
      fill: "rgb(247, 217, 64)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_1_camada_2",
    d: "M18815.08 8192.9c-38.27,-9.45 -80.79,-18.39 -127.56,-27.17 42.52,-20.25 65.91,-41.52 65.91,-63.29 0,-140.75 -950.37,-254.84 -2123.97,-254.84 -1171.48,0 -2123.98,114.09 -2123.98,254.84 0,31.73 48.9,62.11 138.2,90.12 -21.26,-1.51 -44.65,-3.03 -63.78,-4.55l-8.51 -0.51c-23.38,-1.69 -46.77,-3.37 -68.03,-5.23l-8.51 -0.51c-23.38,-1.68 -44.64,-3.54 -68.03,-5.4l-8.51 -0.84c-23.38,-1.69 -44.64,-3.55 -65.91,-5.4l-8.5 -0.68c-23.39,-1.85 -44.65,-3.88 -65.91,-5.73l-4.25 -0.34c-21.26,-2.03 -44.65,-4.05 -65.91,-6.25l-4.25 -0.17c-21.26,-2.19 -42.52,-4.21 -63.78,-6.24l-6.38 -0.68c-19.14,-2.02 -40.4,-4.05 -59.53,-6.07l-8.51 -0.84c-19.13,-2.03 -38.27,-4.06 -57.4,-6.08l-10.63 -1.01c-19.14,-2.03 -36.15,-4.22 -55.28,-6.25l-6.38 -0.84c-19.13,-2.03 -38.27,-4.39 -57.4,-6.58l-6.38 -0.68c-19.14,-2.19 -36.15,-4.56 -55.28,-6.92l-4.25 -0.5c-19.14,-2.37 -38.27,-4.9 -57.41,-7.26l-2.12 -0.17c-76.54,-10.29 -150.96,-21.1 -218.99,-32.07l-4.25 -0.5c-14.89,-2.53 -29.77,-5.07 -44.65,-7.6l-8.51 -1.18c-14.88,-2.53 -27.64,-4.89 -42.52,-7.42l-6.38 -1.19c-12.75,-2.53 -27.64,-5.06 -40.39,-7.59l-6.38 -1.01c-12.76,-2.53 -25.51,-5.07 -38.27,-7.77l-6.38 -1.01c-12.76,-2.53 -25.51,-5.23 -38.27,-7.76l-4.25 -1.18c-12.76,-2.54 -25.51,-5.24 -36.15,-7.77l-6.37 -1.52c-10.63,-2.53 -23.39,-5.23 -34.02,-7.93l-4.25 -1.01c-12.76,-2.7 -23.39,-5.57 -34.02,-8.44l-2.13 -0.67c-12.75,-2.87 -23.38,-5.91 -34.01,-8.78l-2.13 -0.68c-10.63,-2.86 -21.26,-5.9 -31.89,-8.94l-2.13 -0.68c-10.63,-3.03 -19.13,-6.07 -29.76,-9.28l-2.13 -0.5c-8.5,-3.04 -19.13,-6.08 -27.64,-9.12l-2.12 -0.84c-8.51,-3.04 -17.01,-5.91 -23.39,-8.95l-4.25 -1.01c-6.38,-2.7 -12.76,-5.4 -19.14,-7.93 433.72,-179.91 1939,-312.73 3731.3,-312.73 1794.43,0 3299.71,132.82 3733.43,312.73 -6.38,2.53 -12.76,5.23 -19.14,7.93l-4.25 1.01c-6.38,2.87 -14.88,5.91 -23.39,8.78l-4.25 1.01c-8.5,3.04 -17.01,6.08 -25.51,9.12l-2.13 0.5c-8.5,3.04 -19.13,6.08 -29.76,9.12l-4.25 1.01c-8.51,3.04 -19.14,5.91 -29.77,8.77l-2.13 0.68c-10.63,2.87 -21.26,5.91 -34.01,8.78l-2.13 0.67c-10.63,2.87 -23.39,5.74 -34.02,8.44l-4.25 1.01c-10.63,2.7 -23.39,5.4 -34.02,8.1l-6.38 1.35c-10.63,2.53 -23.38,5.23 -36.14,7.77l-6.38 1.18c-10.63,2.7 -23.38,5.23 -36.14,7.76l-6.38 1.01c-12.76,2.7 -25.51,5.24 -38.27,7.77l-6.38 1.18c-14.88,2.53 -27.64,5.06 -42.52,7.59l-4.25 1.02c-14.88,2.53 -29.77,5.06 -44.65,7.59l-4.25 0.84c-14.88,2.54 -31.89,5.07 -46.78,7.6l-4.25 0.84c-17.01,2.53 -34.02,5.23 -51.02,7.77l0 0.16c-36.15,5.57 -72.29,10.81 -110.56,16.04l0 0.17c-19.14,2.53 -38.27,5.06 -59.53,7.76l0 0c-19.14,2.53 -38.27,5.06 -57.41,7.43l-4.25 0.5c-19.13,2.36 -38.27,4.73 -57.4,7.09l-4.26 0.51c-19.13,2.19 -38.27,4.38 -57.4,6.58l-8.5 1.01c-17.01,2.03 -36.15,4.05 -55.28,6.08l-8.51 1.01c-19.13,2.02 -36.14,4.05 -55.28,5.91l-12.75 1.18c-19.14,2.02 -36.15,3.88 -55.28,5.74l-10.63 0.84c-19.14,2.03 -40.4,4.05 -59.53,6.08l-8.51 0.5c-19.13,2.03 -40.39,3.88 -61.65,5.74l-8.51 0.84c-21.26,1.86 -40.39,3.55 -61.65,5.4l-10.64 0.85c-21.26,1.85 -42.52,3.71 -65.9,5.4l-6.38 0.67c-23.39,1.86 -46.78,3.72 -68.04,5.4l-8.5 0.68c-21.26,1.52 -44.65,3.21 -65.91,4.89l-17.01 1.35c-21.26,1.35 -40.4,2.87 -61.66,4.39z",
    style: {
      fill: "rgb(255, 217, 0)"
    },
    transform: "matrix(0.9900475740432739, 0, 0, 0.9900475740432739, 148.7563934326172, 96.0252456665039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6 botao camada_2 area_cor_camada_2",
    d: "M16612.94 9827.75c-657.67,0 -1181.54,-15.01 -1599.08,-38.92 -139.9,-8 -268.13,-17.03 -385.14,-26.82 -333,-27.84 -577.47,-61.95 -756.95,-97 -30.25,-5.92 -58.55,-11.82 -85.21,-17.76 -33.15,-7.38 -63.59,-14.75 -91.59,-22.09 -89.24,-23.39 -153.49,-46.3 -199.77,-67.2 -32.45,-14.66 -56.09,-28.33 -73.26,-40.44 -46.07,-32.53 -45.88,-54.02 -45.88,-54.02l-39.49 -127.58 -5.07 -16.37 -376.89 -1217.13 -4.93 -15.89 -63.14 -203.84 -4.23 -13.69c16.51,26.58 55.85,52.47 115.92,77.47l0 0c432.55,179.94 1939.53,312.74 3732.13,312.74 1792.61,0 3299.59,-132.8 3732.13,-312.74l0 0c60.09,-25 99.4,-50.89 115.9,-77.47l-68.14 220.11 -4.13 13.31 -376.92 1217.13 -11.44 37.03 -33.12 106.92c0,0 -23.61,37.24 -161.72,87.89 -42.74,15.7 -96.52,32.7 -163.91,50.24 -64.1,16.7 -140.52,33.9 -231.71,51.05 -190.9,35.88 -446.38,71.41 -787.42,101 -148.61,12.89 -313.38,24.62 -496.32,34.78 -434.08,24.12 -969.79,39.29 -1630.62,39.29zm3974.32 -1986.91l0 0 0 0zm-7713.79 0l0 0 0 0z",
    style: {
      fill: "rgb(255, 234, 0)"
    },
    transform: "matrix(0.9650825262069701, 0, 0, 0.9650825262069701, 577.0143432617188, 311.4543535126386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13580.0400390625 8631.1201171875 L 13679.7197265625 9163.3203125 L 13995.16015625 8847.8701171875 Z",
    className: "fil7 area_cor_fonte_camada_2",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 16717.03,
    y: 9216.87,
    className: "fil8 fnt0 botao camada_2 area_cor_fonte_camada_2 label_camada_2",
    style: {
      whiteSpace: "pre",
      fill: "rgb(55, 52, 53)",
      fontWeight: "bold",
      fontSize: "405.57px",
      fontFamily: "'Arial'",
      fontWeight: "Arial",
      textAnchor: "middle"
    },
    transform: "matrix(1, 0, 0, 1, -16.36773061418876, 0)"
  }, "N\xEDvel 2"), /*#__PURE__*/React.createElement("path", {
    d: "M 19937.7109375 8631.1201171875 L 19838.029296875 9163.3203125 L 19522.580078125 8847.8701171875 Z",
    className: "fil7 area_cor_fonte_camada_2",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(55, 52, 53)",
      fontWeight: "bold",
      fontSize: "453.57px",
      fontFamily: "Arial",
      color: "rgb(55, 52, 53)"
    },
    x: 11200,
    y: 8489,
    transform: "matrix(1, 0, 0, 1, -81.8386530709422, 16.36773061418853)"
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(55, 52, 53)",
      fontWeight: "bold",
      fontSize: "453.57px",
      fontFamily: "Arial",
      color: "rgb(55, 52, 53)"
    },
    x: 11680,
    dy: 270,
    className: "label camada_2 area_cor_fonte_camada_2"
  }, "0")), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(55, 52, 53)",
      fontWeight: "bold",
      fontSize: "453.57px",
      textAlign: "center",
      fontFamily: "Arial",
      color: "rgb(55, 52, 53)"
    },
    x: 22000,
    y: 8769,
    transform: "matrix(1, 0, 0, 1, -180.04503439523023, 16.36773061418853)",
    className: "label camada_2 area_cor_fonte_camada_2"
  }, "0"), /*#__PURE__*/React.createElement("path", {
    d: "M 23271.158203125 9143.625",
    style: {
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    },
    transform: "matrix(0.929157257080078, 0, 0, 0.929157257080078, 1308.1671153254938, 638.6416625976558)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-9",
    transform: "matrix(0.08791037648916246, 0, 0, 0.08791037648916246, -901.7742502000784, -428.480814064883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20450.310546875 7456.259765625 L 20542.5703125 7456.259765625 L 20809.51953125 7456.259765625 L 20923.2109375 7456.259765625 L 21190.189453125 7456.259765625 L 21303.859375 7456.259765625 L 21570.83984375 7456.259765625 L 21684.529296875 7456.259765625 L 21951.48046875 7456.259765625 L 22065.169921875 7456.259765625 L 22175.1796875 7456.259765625 L 22175.1796875 6239.1298828125 L 21989.98046875 6239.1298828125 L 21876.310546875 6239.1298828125 L 21609.33984375 6239.1298828125 L 21495.640625 6239.1298828125 L 21228.69921875 6239.1298828125 L 21115 6239.1298828125 L 20848.01953125 6239.1298828125 L 20827.19921875 6239.1298828125 Z",
    className: "fil1",
    style: {
      fill: "url('#gradient-107')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 camada_1 botao area_fundo_circulo_camada_1",
    d: "M21643.37 6844.76c0,336.1 272.47,608.58 608.58,608.58 336.08,0 608.54,-272.48 608.54,-608.58 0,-336.08 -272.46,-608.55 -608.54,-608.55 -336.11,0 -608.58,272.47 -608.58,608.55z",
    style: {
      fill: "url('#gradient-108')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20124.359375 6634.97021484375 L 20017.7109375 7204.5 L 19680.130859375 6866.91015625 Z",
    className: "fil0",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12983.41015625 7456.259765625 L 12891.150390625 7456.259765625 L 12624.2099609375 7456.259765625 L 12510.509765625 7456.259765625 L 12243.5302734375 7456.259765625 L 12129.8701171875 7456.259765625 L 11862.8896484375 7456.259765625 L 11749.1904296875 7456.259765625 L 11482.25 7456.259765625 L 11368.5498046875 7456.259765625 L 11258.5498046875 7456.259765625 L 11258.5498046875 6239.1298828125 L 11443.740234375 6239.1298828125 L 11557.41015625 6239.1298828125 L 11824.3896484375 6239.1298828125 L 11938.080078125 6239.1298828125 L 12205.0302734375 6239.1298828125 L 12318.7197265625 6239.1298828125 L 12585.7001953125 6239.1298828125 L 12606.51953125 6239.1298828125 Z",
    className: "fil3",
    style: {
      fill: "url('#gradient-110')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 botao camada_1 area_cor_camada_1",
    d: "M21245.49 5601.83c0,-270.78 -2021.5,-490.3 -4515.13,-490.3 -2493.65,0 -4515.15,219.52 -4515.15,490.3 0,10.86 3.62,21.63 10.02,32.32l578.38 1867.77c0,0 -4.45,426.41 3789.29,426.41 3793.73,0 4064.19,-426.41 4064.19,-426.41l578.4 -1867.77c6.41,-10.69 10,-21.46 10,-32.32z",
    style: {
      fill: "url('#gradient-111')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5 area_cor_interna_1_camada_1",
    d: "M21245.49 5576.13c0,270.77 -2021.5,490.29 -4515.13,490.29 -2493.65,0 -4515.15,-219.52 -4515.15,-490.29 0,-270.78 2021.5,-490.3 4515.15,-490.3 2493.63,0 4515.13,219.52 4515.13,490.3z",
    style: {
      fill: "rgb(0, 168, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6 area_cor_interna_2_camada_1",
    d: "M16543.7 6066.01l0 -0.1 -18.74 0c-102.78,-0.5 -204.61,-1.39 -305.49,-2.62l0 -0.06 -4.93 0c-108.53,-1.34 -215.93,-3.08 -321.99,-5.25l0 -0.11 -5.76 0c-39.35,-0.8 -78.52,-1.68 -117.51,-2.6l0 -0.07 -3.26 0c-34.8,-0.82 -69.43,-1.7 -103.92,-2.61l0 -0.07 -2.92 0c-32.21,-0.86 -64.29,-1.74 -96.23,-2.67l0 -0.02 -0.4 0c-28.56,-0.82 -57.02,-1.67 -85.35,-2.56l0 -0.12 -3.53 0c-52.81,-1.65 -105.25,-3.41 -157.25,-5.27l0 -0.08 -2.24 0c-23.44,-0.85 -46.84,-1.69 -70.11,-2.57l0 -0.11 -2.84 0c-44.96,-1.7 -89.53,-3.5 -133.82,-5.35l0 -0.02 -0.29 0 -61.34 -2.62 0 -0.05 -1.12 0c-39.19,-1.72 -78.15,-3.48 -116.79,-5.31l0 -0.05 -1.11 0 -55.16 -2.68 0 0 -0.19 0c-17.84,-0.88 -35.69,-1.75 -53.4,-2.65l0 -0.03 -0.4 0c-34.06,-1.73 -67.84,-3.51 -101.43,-5.34l0 -0.02 -0.38 0 -47.86 -2.61 0 -0.07 -1.27 0c-61.16,-3.42 -121.44,-7 -180.94,-10.71l0 -0.01 -0.09 0c-55.21,-3.44 -109.65,-7.01 -163.37,-10.69l0 -0.03 -0.3 0 -37.21 -2.56 0 -0.12 -1.61 0c-49.27,-3.45 -97.85,-7.02 -145.78,-10.68l0 -0.04 -0.51 0 -34.32 -2.65 0 -0.03 -0.4 0c-55.32,-4.3 -109.65,-8.75 -163.06,-13.31l0 -0.09 -0.95 0 -31.21 -2.66 0 -0.01 -0.05 0c-39.89,-3.48 -79.1,-7.04 -117.85,-10.66l0 -0.06 -0.69 0c-18.67,-1.74 -37.18,-3.5 -55.58,-5.28l0 -0.08 -0.84 0c-35.94,-3.47 -71.44,-7 -106.34,-10.58l0 -0.14 -1.3 0 -25.5 -2.66 0 -0.02 -0.19 0c-33.45,-3.5 -66.51,-7.04 -98.96,-10.65l0 -0.07 -0.59 0 -23.53 -2.66 0 -0.02 -0.18 0c-23.44,-2.64 -46.59,-5.32 -69.49,-8.03l0 -0.01 -0.05 0c-80.28,-9.47 -157.12,-19.31 -230.4,-29.45l0 -0.02 -0.18 0 -18.57 -2.57 0 -0.11 -0.77 0c-37.33,-5.25 -73.71,-10.56 -109.1,-15.98l0 -0.1 -0.64 0c-11.56,-1.77 -22.85,-3.55 -34.19,-5.34l0 -0.02 -0.15 0c-66.17,-10.42 -128.67,-21.12 -187.43,-32.09l0 -0.06 -0.31 0c-42.07,-7.86 -82.18,-15.86 -120.28,-23.99l0 -0.13 -0.63 0c-24.74,-5.29 -48.7,-10.62 -71.72,-16.01l0 -0.07 -0.28 0 -10.44 -2.51 0 -0.17 -0.7 0c-25.95,-6.18 -50.69,-12.43 -74.33,-18.74l0 -0.02 -0.06 0c-29.48,-7.87 -57.23,-15.84 -83.01,-23.92l0 -0.19 -0.6 0c-2.56,-0.8 -4.93,-1.61 -7.43,-2.41l0 -0.28 -0.84 0c-16.59,-5.3 -32.43,-10.64 -47.4,-16.02l0 -0.05 -0.14 0c-7.36,-2.64 -14.36,-5.31 -21.29,-7.98l0 -0.06 -0.16 0 -4.54 -1.7c3.13,-1.23 6.53,-2.44 9.74,-3.66l0.31 0 0 -0.11c16.56,-6.27 34.22,-12.48 53,-18.65l0.6 0 0 -0.2 7.63 -2.47 0.41 0 0 -0.13c2.64,-0.85 5.18,-1.71 7.86,-2.55l0.17 0 0 -0.06c19.93,-6.29 41.01,-12.53 63.22,-18.71l1.1 0 0 -0.31c6.08,-1.68 12.4,-3.36 18.65,-5.04l0.1 0 0 -0.02c26.88,-7.23 55.21,-14.37 85.11,-21.42l0.64 0 0 -0.15c18.91,-4.45 38.51,-8.87 58.61,-13.25l0.34 0 0 -0.07c12.26,-2.68 24.71,-5.33 37.41,-7.97l0.11 0 0 -0.02 12.89 -2.65 0.51 0 0 -0.11c17.39,-3.56 35.12,-7.1 53.29,-10.62l0.3 0 0 -0.06c13.86,-2.67 27.97,-5.33 42.27,-7.98l0.6 0 0 -0.11c19.27,-3.56 38.8,-7.1 58.86,-10.6l0.1 0 0 -0.02 15.59 -2.66 0.49 0 0 -0.09 15.2 -2.6 0.88 0 0 -0.15c37.16,-6.29 75.47,-12.51 115.17,-18.6l0.05 0 0 -0.01 17.72 -2.67 1.04 0 0 -0.16c11.49,-1.74 22.94,-3.47 34.62,-5.2l0.21 0 0 -0.03c18.29,-2.69 36.81,-5.36 55.59,-8.01l0.69 0 0 -0.09 18.66 -2.58 0.09 0 0 -0.02c45.85,-6.38 93.06,-12.62 141.71,-18.75l0.32 0 0 -0.03 21.15 -2.65 0.28 0 0 -0.03c36.53,-4.52 73.74,-8.98 111.75,-13.37l0.8 0 0 -0.09 22.84 -2.58 1.28 0 0 -0.14c31.5,-3.57 63.38,-7.11 95.86,-10.58l0.6 0 0 -0.07c16.73,-1.78 33.69,-3.54 50.68,-5.29l0.23 0 0 -0.02 25.82 -2.66 0.98 0 0 -0.1c26.36,-2.68 53.09,-5.33 80.04,-7.94l0.35 0 0 -0.03c18.45,-1.79 37.01,-3.57 55.74,-5.33l0.53 0 0 -0.05 28.34 -2.62 1.14 0 0 -0.11c29.1,-2.68 58.44,-5.33 88.17,-7.94l0.26 0 0 -0.02 30.81 -2.66 1.34 0 0 -0.11c42.03,-3.62 84.6,-7.16 127.82,-10.61l0.81 0 0 -0.06c69.53,-5.55 140.53,-10.89 213.02,-16.01l1.35 0 0 -0.09 37.42 -2.59 0.09 0 0 -0.01 38.81 -2.67 1.38 0 0 -0.09c26.47,-1.79 53.14,-3.54 79.97,-5.27l0.43 0 0 -0.03 42 -2.65 0.87 0 0 -0.05 42.19 -2.63 0.69 0 0 -0.04c44.87,-2.74 90.21,-5.41 136.02,-8l0.64 0 0 -0.04 47.96 -2.64 0.27 0 0 -0.01c33.37,-1.83 66.96,-3.61 100.8,-5.35l1.03 0 0 -0.05 52 -2.63 1.59 0 0 -0.07 52.93 -2.61 0.66 0 0 -0.03c38.48,-1.84 77.35,-3.61 116.38,-5.33l1.53 0 0 -0.07 60.05 -2.61 1.58 0 0 -0.07c20.93,-0.89 41.94,-1.75 63.01,-2.6l1.3 0 0 -0.06c45.88,-1.85 92.19,-3.61 138.75,-5.31l3.27 0 0 -0.12c50.64,-1.84 101.65,-3.58 153.07,-5.23l2.35 0 0 -0.08c28.11,-0.89 56.31,-1.76 84.64,-2.6l1.11 0 0 -0.03c30.99,-0.92 62.11,-1.81 93.35,-2.65l0.44 0 0 -0.02c34.4,-0.93 68.97,-1.82 103.68,-2.67l3.5 0 0 -0.08c37.64,-0.92 75.45,-1.78 113.44,-2.6l1.79 0 0 -0.04c44.48,-0.94 89.2,-1.83 134.14,-2.63l2.52 0 0 -0.05c54.84,-0.98 109.97,-1.87 165.46,-2.63l11.4 0 0 -0.15c80.1,-1.08 160.9,-1.91 242.25,-2.53l14.99 0 0 -0.13c100.65,-0.72 202.2,-1.1 304.57,-1.1 102.99,0 205.13,0.38 306.4,1.12l0 0.11 13.16 0c81.97,0.62 163.37,1.46 244.08,2.56l0 0.12 9.57 0c55.21,0.76 110.04,1.64 164.61,2.62l0 0.06 3.37 0c44.66,0.8 89.09,1.67 133.29,2.61l0 0.06 2.64 0c37.7,0.81 75.22,1.67 112.58,2.58l0 0.1 4.35 0c34.42,0.85 68.71,1.73 102.84,2.65l0 0.04 1.28 0c30.96,0.84 61.8,1.71 92.51,2.62l0 0.06 1.96 0c28.04,0.83 55.96,1.69 83.79,2.58l0 0.1 3.19 0c52.04,1.66 103.67,3.44 154.91,5.3l0 0.05 1.43 0c23.72,0.87 47.37,1.75 70.92,2.65l0 0.03 0.79 0c43.81,1.69 87.34,3.44 130.51,5.26l0 0.1 2.43 0 59.2 2.57 0 0.11 2.38 0c38.75,1.72 77.32,3.47 115.52,5.3l0 0.06 1.51 0 52.09 2.56 0 0.12 2.43 0c51.53,2.56 102.52,5.22 152.99,7.98l0 0.06 1.11 0 47.12 2.6 0 0.08 1.48 0c45.53,2.57 90.58,5.22 135.19,7.95l0 0.09 1.52 0 41.35 2.57 0 0.11 1.71 0 41.17 2.6 0 0.08 1.26 0c40.21,2.59 79.93,5.26 119.32,7.98l0 0.06 0.93 0c62.34,4.3 123.73,8.76 183.96,13.37l0 0.03 0.31 0c45.2,3.47 89.72,7.03 133.67,10.68l0 0.03 0.51 0 31.66 2.66 0 0.03 0.38 0c20.54,1.73 40.99,3.48 61.24,5.25l0 0.1 1.09 0c39.51,3.46 78.42,6.99 116.82,10.59l0 0.13 1.36 0 28.11 2.66 0 0.02 0.2 0c45.42,4.33 90.02,8.76 133.79,13.29l0 0.11 1.07 0c66.84,6.91 131.7,14.05 194.54,21.39l0 0.04 0.41 0c15.14,1.77 30.24,3.54 45.14,5.34l0 0.03 0.27 0 21.17 2.59 0 0.09 0.72 0 20.72 2.54 0 0.13 1.11 0 20.33 2.54 0 0.14 1.15 0 20.28 2.59 0 0.1 0.75 0 20.69 2.63 0 0.05 0.34 0c27.16,3.51 53.79,7.08 80.05,10.68l0 0.03 0.29 0 18.47 2.56 0 0.13 0.92 0c31.64,4.39 62.59,8.86 92.86,13.37l0 0.02 0.1 0c11.63,1.74 23.31,3.47 34.74,5.22l0 0.14 0.89 0c11.46,1.76 22.69,3.54 33.94,5.32l0 0.04 0.28 0c55.14,8.71 107.84,17.62 157.82,26.72l0 0.07 0.38 0c14.41,2.63 28.53,5.27 42.5,7.93l0 0.12 0.66 0c32.22,6.13 63.3,12.36 93.13,18.65l0 0.1 0.47 0c12.56,2.65 24.91,5.33 37.04,8.01l0 0.03 0.16 0c27.92,6.17 54.66,12.43 80.23,18.75l0 0.01 0.03 0c21.41,5.29 41.88,10.64 61.6,16.03l0 0.05 0.21 0c6.3,1.72 12.43,3.45 18.56,5.18l0 0.18 0.61 0c15.53,4.39 30.52,8.81 44.94,13.26l0 0.13 0.42 0 7.61 2.36 0 0.33 1.01 0c19.56,6.16 37.95,12.38 55.26,18.65l0 0.1 0.26 0c7.28,2.64 14.31,5.29 21.19,7.95l0 0.09 0.25 0 2.59 0.98 -4.54 1.7 -0.98 0 0 0.37c-4.35,1.67 -8.8,3.33 -13.3,4.99l-0.1 0 0 0.04c-34.51,12.71 -73.64,25.22 -117.17,37.48l-0.74 0 0 0.21c-6.11,1.72 -12.3,3.43 -18.58,5.14l-0.18 0 0 0.05c-33.28,9.05 -68.95,17.97 -106.97,26.75l-0.21 0 0 0.04c-15.52,3.59 -31.48,7.14 -47.77,10.68l-0.47 0 0 0.1c-12.27,2.65 -24.74,5.31 -37.44,7.94l-0.07 0 0 0.02c-17.35,3.59 -35.11,7.15 -53.26,10.7l-0.33 0 0 0.07 -13.31 2.6 -0.09 0 0 0.02c-13.98,2.69 -28.23,5.37 -42.67,8.03l-0.21 0 0 0.03c-29.39,5.42 -59.75,10.77 -90.97,16.04l-0.13 0 0 0.02 -15.73 2.66 -0.35 0 0 0.06 -16.05 2.62 -0.03 0 0 0.01c-38.67,6.35 -78.65,12.61 -119.94,18.75l-0.64 0 0 0.09c-30.23,4.5 -61.19,8.93 -92.78,13.31l-1.01 0 0 0.14 -18.39 2.54 -0.37 0 0 0.05c-33.08,4.52 -66.94,8.96 -101.44,13.35l-0.39 0 0 0.05 -20.64 2.63 -0.79 0 0 0.1 -20.94 2.58 -0.5 0 0 0.06 -21.35 2.61 -0.09 0 0 0.01c-29.7,3.62 -59.83,7.19 -90.49,10.71l-0.62 0 0 0.07 -23.1 2.61 -1.01 0 0 0.12c-39.97,4.51 -80.73,8.94 -122.24,13.28l-1.02 0 0 0.11c-25.61,2.67 -51.49,5.32 -77.66,7.93l-0.06 0 0 0c-27.18,2.72 -54.59,5.4 -82.38,8.04l-0.68 0 0 0.07c-47.96,4.55 -96.78,9 -146.5,13.33l-0.89 0 0 0.08c-52.48,4.57 -106,9 -160.37,13.32l-0.41 0 0 0.03 -33.59 2.64 -1.24 0 0 0.1 -33.48 2.58 -1.36 0 0 0.1 -34.19 2.59 -0.64 0 0 0.04c-48.95,3.66 -98.6,7.22 -148.92,10.67l-1.14 0 0 0.08c-39.6,2.72 -79.62,5.38 -120.04,7.96l-0.54 0 0 0.03 -41.95 2.65 -0.93 0 0 0.06 -42.73 2.62 -0.14 0 0 0.01c-29.92,1.82 -60.06,3.6 -90.4,5.35l-0.71 0 0 0.04 -46.13 2.64 -2.11 0 0 0.11 -47.01 2.57 -1.22 0 0 0.07c-33.32,1.81 -66.81,3.58 -100.59,5.29l-1.23 0 0 0.06 -52.57 2.62 -1.03 0 0 0.05 -54.32 2.63 -1.95 0 0 0.09c-38.37,1.81 -77.04,3.57 -115.94,5.27l-1.96 0 0 0.08 -60.5 2.59 -1.13 0 0 0.05c-44.02,1.84 -88.32,3.62 -132.99,5.32l-1 0 0 0.03c-23.88,0.91 -47.89,1.79 -71.95,2.65l-3.08 0 0 0.11c-51.72,1.86 -103.88,3.59 -156.41,5.24l-1.69 0 0 0.06c-28.94,0.91 -58,1.77 -87.18,2.62l-1.25 0 0 0.04c-31.66,0.92 -63.46,1.8 -95.38,2.65l-1.09 0 0 0.03c-35.1,0.92 -70.34,1.8 -105.76,2.65l-1.42 0 0 0.04c-39.59,0.93 -79.37,1.81 -119.34,2.63l-3.92 0 0 0.08c-106.65,2.18 -214.68,3.93 -323.84,5.28l-5.76 0 0 0.08c-100.59,1.23 -202.18,2.1 -304.65,2.6l-16.91 0 0 0.09c-62.5,0.29 -125.34,0.42 -188.49,0.42 -62.53,0 -124.74,-0.14 -186.66,-0.41z",
    style: {
      fill: "rgb(18, 179, 110)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7 area_cor_interna_3_camada_1",
    d: "M16543.7 6066.01l0 -0.1 -19.94 0c-102.37,-0.5 -203.82,-1.37 -304.29,-2.6l0 -0.08 -6.31 0c-108.08,-1.33 -214.99,-3.1 -320.61,-5.25l0 -0.11 -5.44 0c-39.45,-0.81 -78.74,-1.68 -117.83,-2.6l0 -0.07 -3.2 0c-34.81,-0.82 -69.47,-1.7 -103.98,-2.6l0 -0.08 -3.12 0c-32.15,-0.86 -64.16,-1.74 -96.03,-2.67l0 -0.02 -0.59 0c-28.5,-0.82 -56.88,-1.69 -85.16,-2.57l0 -0.11 -3.5 0c-52.83,-1.66 -105.27,-3.42 -157.28,-5.28l0 -0.07 -2 0c-23.54,-0.85 -46.99,-1.71 -70.35,-2.6l0 -0.08 -2.27 0c-45.12,-1.72 -89.92,-3.51 -134.39,-5.37l-0.05 0 -61.58 -2.63 0 -0.04 -0.89 0c-39.28,-1.72 -78.29,-3.5 -117.02,-5.33l0 -0.03 -0.71 0c-69.88,-3.31 -138.84,-6.81 -206.83,-10.48l0.75 -0.24 0.46 0 0 -0.14c19.77,-6.34 42.06,-12.55 66.65,-18.61l0.34 0 0 -0.09 10.66 -2.6 0.06 0 0 -0.01c15.17,-3.62 31.17,-7.19 47.99,-10.7l0.24 0 0 -0.06c12.9,-2.69 26.27,-5.36 40.11,-7.99l0.09 0 0 -0.01c65.07,-12.38 140.47,-24.02 224.81,-34.82l0.28 0 0 -0.04 20.96 -2.64 0.48 0 0 -0.06 21.36 -2.62 0.07 0 0 0c63.4,-7.63 131.42,-14.79 203.6,-21.44l0.06 0 0 -0.01 29.46 -2.66 0.01 0c31.27,-2.78 63.28,-5.47 96,-8.05l0.47 0 0 -0.04 34.18 -2.63 0.66 0 0 -0.05c50.17,-3.79 101.93,-7.36 155.14,-10.68l0.28 0 0 -0.01c29.73,-1.86 59.9,-3.64 90.52,-5.34l0.58 0 0 -0.03c52.3,-2.9 105.88,-5.58 160.58,-8.01l0.2 0 0 -0.01c43.55,-1.93 87.79,-3.73 132.73,-5.35l1.26 0 0 -0.05c25.84,-0.93 51.91,-1.81 78.18,-2.63l2.2 0 0 -0.07c68.08,-2.14 137.59,-3.9 208.31,-5.29l3.38 0 0 -0.06c58.38,-1.14 117.61,-2.01 177.53,-2.62l2.01 0 0 -0.02c65,-0.66 130.81,-1 197.38,-1 66.28,0 131.81,0.34 196.53,0.99l0 0.03 2.86 0c60.56,0.62 120.39,1.5 179.36,2.65l0 0.03 1.55 0c39.17,0.77 77.95,1.66 116.35,2.66l0 0.02 0.56 0c31.34,0.82 62.44,1.69 93.23,2.66l0 0.02 0.37 0c72.11,2.26 142.6,4.94 211.32,8l0 0.04 1.04 0c19.43,0.87 38.77,1.76 57.91,2.68l0.04 0c109.74,5.3 214.52,11.59 313.48,18.75l0 0.01 0.11 0c78.87,5.71 154.02,11.98 224.98,18.75 18.15,1.73 36.01,3.5 53.6,5.3l0 0.06 0.64 0c25.38,2.6 50.2,5.26 74.38,7.99l0 0.05 0.46 0c146.62,16.55 270.61,35.5 366.66,56.22l0 0.05 0.25 0c8.15,1.76 16.12,3.52 23.86,5.31l0 0.05 0.22 0c34.19,7.89 64.39,16.02 90.28,24.36 -32.37,1.74 -64.97,3.46 -97.77,5.12l-0.76 0 0 0.04 -52.8 2.64 -0.8 0 0 0.03 -54.7 2.65 -1.57 0 0 0.07c-38.45,1.83 -77.17,3.59 -116.16,5.29l-1.74 0 0 0.08 -60.73 2.59 -0.9 0 0 0.04c-44.19,1.86 -88.71,3.62 -133.55,5.33l-0.44 0 0 0.01c-23.96,0.91 -48.03,1.8 -72.17,2.67l-2.86 0 0 0.1c-51.74,1.85 -103.88,3.6 -156.42,5.25l-1.68 0 0 0.06c-28.88,0.9 -57.87,1.78 -86.99,2.62l-1.44 0 0 0.04c-31.58,0.92 -63.31,1.8 -95.17,2.65l-1.3 0 0 0.03c-35.11,0.93 -70.37,1.8 -105.8,2.65l-1.38 0 0 0.03c-39.69,0.93 -79.58,1.81 -119.65,2.64l-3.61 0 0 0.08c-106.21,2.17 -213.74,3.94 -322.45,5.28l-7.15 0 0 0.09c-100.19,1.23 -201.37,2.09 -303.44,2.59l-18.12 0 0 0.09c-62.51,0.29 -125.34,0.42 -188.49,0.42 -62.53,0 -124.75,-0.14 -186.66,-0.41z",
    style: {
      fill: "rgb(139, 204, 162)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13309.3701171875 6634.97021484375 L 13416.009765625 7204.5 L 13753.58984375 6866.91015625 Z",
    className: "fil0 area_cor_fonte_camada_1",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19950.0703125 6681.9599609375 L 19890.720703125 7204.5 L 19553.130859375 6866.91015625 Z",
    className: "fil0 area_cor_fonte_camada_1",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 16499.62,
    y: 7180.6,
    className: "fil0 fnt0 botao camada_1 area_cor_fonte_camada_1 label_camada_1",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "455.39px",
      fontFamily: "'Arial'",
      fontWeight: "Arial",
      textAnchor: "middle"
    }
  }, "N\xEDvel 1"), /*#__PURE__*/React.createElement("path", {
    className: "fil8 camada_1 botao area_fundo_circulo_camada_1",
    d: "M11790.35 6844.76c0,336.1 -272.47,608.58 -608.58,608.58 -336.07,0 -608.54,-272.48 -608.54,-608.58 0,-336.08 272.47,-608.55 608.54,-608.55 336.11,0 608.58,272.47 608.58,608.55z",
    style: {
      fill: "url('#gradient-109')"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 10750,
    y: 7050,
    className: "fil0 fnt0 fnt1",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "'Arial'",
      fontWeight: "Arial"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "multi-line-text",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    transform: "matrix(1.0520879030227661, 0, 0, 1.0520879030227661, -1285.4240722656255, -360.78230571079894)",
    x: 21850,
    y: 6611
  }, /*#__PURE__*/React.createElement("tspan", {
    alignmentBaseline: "middle",
    style: {
      whiteSpace: "pre",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 22350,
    dy: 270,
    className: "camada_1 label area_cor_fonte_camada_1"
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "bold",
      fontSize: "485.39px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    transform: "matrix(0.09398744255304337, 0, 0, 0.09398744255304337, -2024.716904661287, -471.2433166503906)",
    x: 22400,
    y: 6911,
    className: "camada_1 label area_cor_fonte_camada_1"
  }, "0")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.02753476239740849, 0, 0, 0.02753476239740840, -212.3546248783889, -133.04720874344886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-3",
    transform: "matrix(0.9999999999999999, 0, -0.02, 1.3099999999999999, 0, 70.62655811560398)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19732.92 15249.02l-28.92 0 -110.35 0 -259.17 0 -110.37 0 -259.14 0 -110.37 0 -259.17 0 -110.34 0 -259.17 0 -110.37 0 -259.14 0 -110.37 0 -259.17 0 -110.35 0 -62.42 0c517.03,-44.03 570.92,-103.8 570.92,-103.8l288.8 -655.85c3.41,-3.85 5.15,-7.7 5.2,-11.6 0,-0.06 0,-0.11 0,-0.19 0,-20.89 -48.77,-40.93 -138.05,-59.47l147.57 0 110.37 0 259.15 0 110.37 0 1059.16 0 110.35 0 1059.16 0 110.38 0 325.44 0 0 830.91zm-1553.9 -771.25l0 0zm0 -0.19l0 0z",
    style: {
      fill: "url('#gradient-7')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 camada_7 botao area_cor_camada_7",
    d: "M16739.43 15367.88c-4.59,0 -9.13,0 -13.69,0 -57.76,-0.07 -112.89,-0.57 -165.23,-1.43 -23.83,-0.41 -47.01,-0.89 -69.76,-1.44 -57.42,-1.38 -111.41,-3.27 -162.19,-5.57 -23.45,-1.05 -46.18,-2.19 -68.3,-3.44 -57,-3.17 -109.62,-6.9 -158.14,-11.09 -22.96,-1.98 -45.06,-4.05 -66.24,-6.24 -56.81,-5.8 -107.32,-12.29 -152.21,-19.16 -18.91,-2.92 -36.79,-5.9 -53.75,-8.93 -305.82,-54.79 -305.25,-129.16 -305.25,-129.16l-185.31 -816.17c7.54,16.53 27.69,32.53 59.08,47.81l0 0c21.3,10.38 47.77,20.42 78.96,30.07 101.27,103.12 647.49,181.88 1306.11,181.88 658.6,0 1204.81,-78.76 1306.09,-181.88 31.19,-9.65 57.66,-19.69 78.98,-30.07l0 0c31.37,-15.28 51.54,-31.28 59.06,-47.81l-185.29 816.17c0,0 -34.58,74.37 -366.31,129.16 -41.95,6.92 -88.67,13.55 -140.65,19.65 -24.47,2.89 -50,5.64 -76.87,8.29 -53.78,5.28 -112.56,10.03 -176.62,14.09 -23.9,1.52 -48.51,2.93 -73.91,4.25 -53.6,2.78 -110.7,5.1 -171.34,6.9 -23.51,0.69 -47.54,1.3 -72.14,1.82 -53.29,1.14 -109.22,1.87 -167.87,2.16 -18.81,0.09 -37.83,0.14 -57.21,0.14zm1491.55 -1017.06l0 0 0 0zm-2894.95 0l0 0 0 0z",
    style: {
      fill: "rgb(55, 52, 53)"
    },
    transform: "matrix(0.9547682404518129, 0, 0, 0.9547682404518129, 747.773458669064, 672.1162109375)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1962010435552",
    transform: "matrix(0.98496009523603, 0, 0, 0.98496009523603, 232.7814772257892, 229.96639602300007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil2 area_cor_interna_2_camada_7",
    d: "M16441.92 14558.98c12.71,1.82 23.93,3.2 32.15,3.57 43.36,2.07 65.04,10.98 97.93,11.98l-0.75 47.73c69.52,1.82 139.79,2.76 212.3,2.76l0 0c658.59,0 1205.05,-78.77 1305.97,-181.88 -111.38,34.49 -283.32,63.85 -495.62,85.11 -231,23.2 -509.83,36.75 -810.35,36.75 -117.36,0 -231.74,-2.07 -341.63,-6.02z",
    style: {
      fill: "rgb(96, 96, 98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2 area_cor_interna_2_camada_7",
    d: "M16571.25 14622.26l0.75 -47.73c-32.89,-1 -54.57,-9.91 -97.93,-11.98 -8.22,-0.37 -19.44,-1.75 -32.15,-3.57 -169.69,-6.08 -328.17,-16.62 -468.71,-30.73 -212.3,-21.26 -384.24,-50.62 -495.62,-85.11 89.7,91.82 533,164.32 1093.66,179.12z",
    style: {
      fill: "rgb(96, 96, 98)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil1 area_cor_interna_1_camada_7",
    d: "M17604.65 14534.08c-159.59,-46.04 -474.87,-77.39 -837.88,-77.39 -363,0 -679.06,31.35 -837.87,77.39 -219.84,-22.79 -397.43,-54.33 -513.21,-91.26 -10.95,-12.08 -17.21,-24.51 -17.21,-37.21 0,-8.02 2.35,-16.04 7.04,-23.97 171.33,-57.11 481.91,-113.51 869.95,-134.05 149.43,-7.84 315.28,-0.9 482.7,-0.9 603.96,0 1132.81,55.85 1369.08,134.95 4.69,7.93 7.04,15.95 7.04,23.97 0,12.7 -5.48,25.13 -17.21,37.21 -115.01,36.93 -293.38,68.47 -512.43,91.26l0 0z",
    style: {
      fill: "rgb(43, 40, 41)"
    },
    transform: "matrix(1.0000008812247125, 0, 0, 1.0000008812247125, -0.012823625869657462, 11.363086802797056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15722.3701171875 14775.509765625 L 15756.5400390625 15024.259765625 L 15864.6201171875 14876.8095703125 Z",
    className: "fil3 area_cor_fonte_camada_7",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17848.759765625 14796.0498046875 L 17829.759765625 15024.259765625 L 17721.669921875 14876.8095703125 Z",
    className: "fil3 area_cor_fonte_camada_7",
    style: {
      fill: "rgb(254, 254, 254)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.733167 0 0 1 4269.16 5677.93)"
  }, /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(254, 254, 254)",
      fontWeight: "normal",
      fontSize: "497.72px",
      fontFamily: "Arial",
      color: "rgb(254, 254, 254)"
    },
    x: 17098.15,
    y: 9401,
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -178.59758163532342, 0)",
    className: "label camada_7 area_cor_fonte_camada_7"
  }, "0")), /*#__PURE__*/React.createElement("text", {
    x: 18250.35,
    y: 14924.5,
    className: "fil1 fnt1 label_camada_7",
    style: {
      whiteSpace: "pre",
      fill: "rgb(55, 52, 53)",
      fontWeight: "bold",
      fontSize: "315.01px",
      fontFamily: "'Arial'",
      fontWeight: "Arial"
    }
  }, "Roubo"), /*#__PURE__*/React.createElement("g", {
    id: "_1962010434208",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 11.375222971561016)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_2_camada_7",
    d: "M16625.79 14568.32c77.59,-15.44 245.78,-19.9 320,-42.72l158.07 -20.47c20.72,-3.88 112.77,-12.05 189.4,-27.57 -70.36,-7.55 -147.47,-13.66 -231.33,-17.99 -102.16,23.07 -370.11,29.71 -435.66,30 -90.12,0.46 -173.97,-8.58 -255.42,-9.57 -26.02,-0.33 -61.68,-2.69 -97.34,-7.14 -155.18,14.57 -278.56,35.82 -350.85,61.08l0.97 0.08 21.2 1.94 5.3 0.41c9.16,0.83 18.8,1.65 27.96,2.44l14.45 1.15 15.42 1.28 20.73 1.61 10.12 0.79 26.02 1.9 9.64 0.7 26.02 1.81 8.2 0.5 27.95 1.81 8.19 0.54 24.1 1.49 13.49 0.74 26.03 1.49 5.3 0.28c11.08,0.58 21.68,1.16 32.77,1.7l3.85 0.2c10.12,0.5 20.73,1.03 31.33,1.53l7.71 0.33 30.84 1.36 7.71 0.33 32.77 1.28 2.41 0.13c12.05,0.45 24.1,0.86 35.67,1.27l2.89 0.13c12.05,0.37 24.09,0.78 36.14,1.15l1.93 0.05c12.53,0.37 25.06,0.74 37.59,1.07l0.48 0c12.53,0.33 24.58,0.62 37.11,0.91l4.34 0.12c12.05,0.25 24.58,0.54 37.11,0.74l0.96 0.04c12.05,0.21 24.1,0.42 36.14,0.62l6.27 0.09 26.02 0.37z",
    style: {
      fill: "rgb(120, 43, 36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_2_camada_7",
    d: "M17293.26 14477.56c-76.63,15.52 -168.68,23.69 -189.4,27.57l-158.07 20.47c-74.22,22.82 -242.41,27.28 -320,42.72l10.12 0.08 2.41 0.04c13.01,0.17 25.54,0.25 38.07,0.37l2.9 0c26.5,0.21 53.49,0.33 80.48,0.33l0 0c26.99,0 53.49,-0.12 80.48,-0.33l2.41 0c12.53,-0.12 25.54,-0.2 38.07,-0.37l2.89 -0.04c12.05,-0.12 23.62,-0.29 35.66,-0.45l6.27 -0.09c12.53,-0.2 24.58,-0.41 36.63,-0.62l0.96 -0.04c12.53,-0.2 24.58,-0.49 37.11,-0.74l4.34 -0.12c12.04,-0.25 24.57,-0.58 36.62,-0.91l0.48 0c12.53,-0.33 25.06,-0.7 37.59,-1.07l1.93 -0.05c12.05,-0.37 24.1,-0.74 36.15,-1.15l2.89 -0.13c12.05,-0.41 23.61,-0.82 35.66,-1.27l2.89 -0.09c10.6,-0.45 21.69,-0.86 32.29,-1.32l7.71 -0.33 30.84 -1.36 7.72 -0.33c10.6,-0.5 21.2,-0.99 31.8,-1.53l3.38 -0.2c11.08,-0.54 22.16,-1.12 33.25,-1.7l4.82 -0.28 26.5 -1.49 13.02 -0.74 24.57 -1.53 7.71 -0.45 28.44 -1.86 7.71 -0.5 26.02 -1.81 9.64 -0.7 26.03 -1.9 10.12 -0.79 20.24 -1.61 16.38 -1.28 13.98 -1.15 28.43 -2.44 4.82 -0.41 21.69 -1.98 0.48 -0.04c-65.06,-22.66 -170.6,-42.1 -303.13,-56.38z",
    style: {
      fill: "rgb(120, 43, 36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 area_cor_interna_2_camada_7",
    d: "M16273.51 14472.86c35.66,4.45 71.32,6.81 97.34,7.14 81.45,0.99 165.3,10.03 255.42,9.57 65.55,-0.29 333.5,-6.93 435.66,-30 -94.45,-4.91 -196.14,-7.6 -302.16,-7.6 -178.8,0 -345.54,7.68 -486.26,20.89z",
    style: {
      fill: "rgb(120, 43, 36)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConeLogistico);
export default __webpack_public_path__ + "static/media/cone_logistico.6fe60a7e8f1735e4301c8c62687547dd.svg";
export { ForwardRef as ReactComponent };